//#region imports

import CloseIcon from '@mui/icons-material/Close';
import { Box, Button, FormControl, FormControlLabel, Grid, Radio, RadioGroup, Typography } from '@mui/material';
import Backdrop from '@mui/material/Backdrop';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import React, { forwardRef, useEffect, useImperativeHandle, useLayoutEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import '../../../style/common.scss';
//jspdf
import { jsPDF } from "jspdf";
import 'jspdf-autotable';
//fonts
import ErrorIcon from '@mui/icons-material/Error';
import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import PrintIcon from '@mui/icons-material/Print';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import { useFormik } from 'formik';
import 'react-toastify/dist/ReactToastify.css';
import useScanDetection from 'use-scan-detection';
import * as Yup from "yup";
import CheckPermissions from '../../../authorization/authorization';
import { resolveDiscoCompanyCodeForBranding, resolveDiscoCodeForDocument, getDiscoUseOnlyWatermarkText } from '../../../utils/adminCompany';
import { drawDnDetailValue, drawDnDueDate } from '../../../utils/dnPdfReadableFonts';
import Base64Image from '../../../components/Base64Image/Base64Image';
import StepProgressBar from '../../../components/StepProgressBar/StepProgressBar';
import BasicTable from '../../../components/basicTable/basicTable';
import ProcessingSummaryTable from '../../../components/processingSummaryTable/processingSummaryTable';
import tickicon from "../../../images/Accept.png";
import pdfIcon from '../../../images/pdfIcon.png';
import crossIcon from "../../../images/remove.png";
import MEPCOWaterMark from '../../../images/DiscosWater/mepcco-watermark.png';
import LESCOWaterMark from '../../../images/DiscosWater/lescowatermark.png';
import IESCOWaterMark from '../../../images/DiscosWater/iescowatermark.png';
import FESCOWaterMark from '../../../images/DiscosWater/fesco-watermark.png';
import GEPCOWaterMark from '../../../images/DiscosWater/gepco-watermark.png';
import HAZECOWaterMark from '../../../images/DiscosWater/hazeco-watermark.png';
import HESCOWaterMark from '../../../images/DiscosWater/hesco-watermark.png';
import TESCOWaterMark from '../../../images/DiscosWater/tesco-watermark.png';
import SEPCOWaterMark from '../../../images/DiscosWater/sepco-watermark.png';
import PESCOWaterMark from '../../../images/DiscosWater/pesco-watermark.png';
import QESCOWaterMark from '../../../images/DiscosWater/qesco-watermark.png';
import { cfpBaseUrl } from '../../../network/urls';
import { companyName, convertDate, convertDatewithTime, dBillAPI, divisionName, documentValidation, getDocumentBackGroundColor, numberFormatting, printStamp, statusFunc, subdivisionName } from '../../../services/Functions';
import { openBase64Image } from '../../../services/OpenBase64Image';
import OpenBase64ImageInPopup from '../../../services/OpenBase64ImageInPopup';
import { tableStyle, tableStyleOverDue } from '../../../style/common';
import {
  fetchPaginatedChangeOfTariffNormal,
  nextPage as nextPageNormal,
  previousPage as prePageNormal,
  firstPage as firstPageNormal,
  lastPage as lastPageNormal,
  filterProgressId as filterProgressIdNormal,
  filterDateFrom as filterDateFromNormal,
  filterDateTo as filterDateToNormal,
  filterObjectionStatus as filterObjectionStatusNormal,
  resetProgressIdFilter as resetProgressIdFilterNormal,
  resetObjectionStatusFilter as resetObjectionStatusFilterNormal,
  resetDateFilter as resetDateFilterNormal
} from '../../../features/generalServices/cotNormalSlice';
import {
  fetchPaginatedChangeOfTariffOverdue,
  nextPage as nextPageOverdue,
  previousPage as prePageOverdue,
  firstPage as firstPageOverdue,
  lastPage as lastPageOverdue,
  filterProgressId as filterProgressIdOverdue,
  filterDateFrom as filterDateFromOverdue,
  filterDateTo as filterDateToOverdue,
  filterObjectionStatus as filterObjectionStatusOverdue,
  resetProgressIdFilter as resetProgressIdFilterOverdue,
  resetObjectionStatusFilter as resetObjectionStatusFilterOverdue,
  resetDateFilter as resetDateFilterOverdue
} from '../../../features/generalServices/cotOverdueSlice';
import { useSelector, useDispatch } from 'react-redux';
import warning from '../../../images/warning.png';
import { signOut } from '../../../features/authentication/authenticationSlice';
import { SearchIndividualApplication } from '../../../network/APIs/APIs';
import { documentExtensions } from '../../../utils/PortalName';
//#endregion

const ChangeTariffTable = forwardRef((props, ref) => {

  const dispatch = useDispatch();

  const { currentPage: currentPageNormal, data: dataNormal, pageSize: pageSizeNormal, totalPages: totalPagesNormal, totalRecords: totalRecordsNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal, error: cotNormalError,isLoading: isLoad } = useSelector((state) => state.cotNormalPaginated);
  const { currentPage: currentPageOverdue, data: dataOverdue, pageSize: pageSizeOverdue, totalPages: totalPagesOverdue, totalRecords: totalRecordsOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue, error: cotOverdueError ,isLoading: isLoadd} = useSelector((state) => state.cotOverduePaginated);

  const handleNextPageNormal = () => {
    dispatch(nextPageNormal());
  };

  const handleDateFromFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterDateFromNormal(value))
    }
  }

  const handleDateToFilterNormal = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterDateToNormal(value))
    }
  }

  const handleResetDateFilterNormal = () => {
    dispatch(resetDateFilterNormal())
  }

  const handleProgressIdFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true)
      dispatch(filterProgressIdNormal(value))
    }
  }

  const handleResetProgressIdFilterNormal = () => {
    dispatch(resetProgressIdFilterNormal())
  }

  const handleObjectionStatusFilterNormal = (value) => {
    if (value || value === 0) {
      setViewBackdrop(true)
      dispatch(filterObjectionStatusNormal(value))
    }
  }

  const handleResetObjectionStatusFilterNormal = () => {
    dispatch(resetObjectionStatusFilterNormal())
  }

  const handlePreviousPageNormal = () => {
    dispatch(prePageNormal());
  };

  const handleFirstPageNormal = () => {
    dispatch(firstPageNormal());
  };

  const handleLastPageNormal = (page) => {
    dispatch(lastPageNormal(typeof page === 'number' ? page : totalPagesNormal));
  };

  useEffect(() => {
    if ((props.showTable && currentPath == "/change-of-tariff-table")) {
      if (token) {
        dispatch(fetchPaginatedChangeOfTariffNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
      }
    }
  }, [currentPageNormal, pageSizeNormal, dateFromNormal, dateToNormal, applicationProgressIdNormal, objectionStatusNormal]);

  useEffect(() => {
    if ((props.showTable && currentPath == "/change-of-tariff-table")) {
      dispatch(fetchPaginatedChangeOfTariffNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
    }
  }, []);

  useEffect(() => {
    if (dataNormal) {
      setChangeOfTariffApplications(dataNormal)
      setViewBackdrop(false)
    }
  }, [dataNormal])


  const handleNextPageOverdue = () => {
    dispatch(nextPageOverdue());
  };

  const handleDateFromFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterDateFromOverdue(value))
    }
  }

  const handleDateToFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterDateToOverdue(value))
    }
  }
  const handleResetDateFilterOverdue = () => {
    dispatch(resetDateFilterOverdue())
  }
  const handleProgressIdFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterProgressIdOverdue(value))
    }
  }

  const handleResetProgressIdFilterOverdue = () => {
    dispatch(resetProgressIdFilterOverdue())
  }

  const handleObjectionStatusFilterOverdue = (value) => {
    if (value) {
      setViewBackdrop(true)
      dispatch(filterObjectionStatusOverdue(value))
    }
  }

  const handleResetObjectionStatusFilterOverdue = () => {
    dispatch(resetObjectionStatusFilterOverdue())
  }

  const handlePreviousPageOverdue = () => {
    dispatch(prePageOverdue());
  };

  const handleFirstPageOverdue = () => {
    dispatch(firstPageOverdue());
  };

  const handleLastPageOverdue = (page) => {
    dispatch(lastPageOverdue(typeof page === 'number' ? page : totalPagesOverdue));
  };

  useEffect(() => {
    if ((props.showTable && currentPath == "/change-of-tariff-table")) {
      dispatch(fetchPaginatedChangeOfTariffOverdue({ page: currentPageOverdue, pageSize: pageSizeOverdue, dateFrom: dateFromOverdue, dateTo: dateToOverdue, applicationProgressId: applicationProgressIdOverdue, objectionStatus: objectionStatusOverdue }));
    }
  }, [currentPageOverdue, pageSizeOverdue, dateFromOverdue, dateToOverdue, applicationProgressIdOverdue, objectionStatusOverdue]);

  useEffect(() => {
    if (dataOverdue) {
      setChangeOfTariffApplicationsOverDue(dataOverdue)
      setViewBackdrop(false)
    }
  }, [dataOverdue])


  //#region initial values

  const initialValues = {
    iv_objection_Type: '',
    iv_objection_Descripton: '',
    iv_distance: '',
    iv_sketch_diagram: '',
    iv_property_reference_no: '',

    // arrear bill document
    iv_arear_paid_bill_document: '',
    iv_arear_paid_bill_date: '',

    // signed consent
    iv_signed_consent_image: '',
  }

  //#endregion

  //#region variable / constants

  var remarksToSave = "";

  let COTStatusBarArray = [
    {
      title1: 'DOCUMENT',
      title2: 'SUBMISSION',
    },
    {
      title1: 'DOCUMENT',
      title2: 'VERIFICATION',
    },
    {
      title1: 'ARREAR',
      title2: 'VERIFICATION',
    },
    {
      title1: 'SITE',
      title2: 'SURVEY',
    },
    {
      title1: 'SIGNED CONSENT ',
      title2: 'VALIDATION',
    },
    {
      title1: 'DN PAYMENT',
      title2: 'SUBMISSION',
    },
    {
      title1: 'DN PAYMENT',
      title2: 'VERIFICATION',
    },
    {
      title1: 'SERVICE',
      title2: 'CONNECTION ORDER',
    },
  ]

  const { token, showAllApplicationsFlag, userId, code, hierarchy, permissions, roleId, selectedAdminCompanyCode } = useSelector((state) => state.auth)
 let userCompany = resolveDiscoCompanyCodeForBranding(
    code,
    roleId,
    selectedAdminCompanyCode,
  );

  const getDocumentDiscoCode = (applicationId, fallbackCompanyCode = "") =>
    resolveDiscoCodeForDocument(
      applicationId,
      code,
      roleId,
      selectedAdminCompanyCode,
      fallbackCompanyCode,
    );
  //#endregion

  //#region get item local storage 
  const subDivisions = JSON.parse(window.localStorage.getItem('subDivisions'));
  //#endregion

  //#region states
  const [open, setOpen] = React.useState(false);
  const [dialogRowData, setDialogRowData] = React.useState({});
  const [changeOfTariffApplications, setChangeOfTariffApplications] = useState([]);
  const [changeOfTariffApplicationsToDataGrid, setChangeOfTariffApplicationsToDataGrid] = useState([]);
  const [changeOfTariffApplicationsOverDue, setChangeOfTariffApplicationsOverDue] = useState([]);
  const [changeOfTariffApplicationsOverDueToDataGrid, setChangeOfTariffApplicationsOverDueToDataGrid] = useState([]);
  const [arrearFlag, setArearFlag] = useState(0);

  const [arearPaidBillUpload, setArearPaidBillUpload] = useState(false);
  const [arearPaidBillDocument, setArearPaidBillDocument] = useState('');
  const [arearPaidBillDocumentError, setArearPaidBillDocumentError] = useState('');
  const [arearPaidBillDocumentThumbnail, setArearPaidBillDocumentThumbnail] = useState('');
  const [consentVerificationFlag, setConsentVerificationFlag] = useState(0);

  const [showDNPayment, setShowDNPayment] = useState(true);
  const [paidDNImagePopUp, setPaidDNImagePopUp] = useState(false);

  const [dnPaymentDate, setDnPaymentDate] = useState()
  const [dnImage, setDnImage] = useState()
  const [dnPaymentVerifyAlert, setDnPaymentVerifyAlert] = React.useState(false);
  const [dnPaymentRejectAlert, setDnPaymentRejectAlert] = React.useState(false);
  const [noArrears, setNoArrears] = useState('');
  const [officeHierarchy, setOfficeHierarchy] = useState();
  const navigate = useNavigate();
  const [signedConsentFormImage, setSignedConsentFormImageImage] = useState();
  const [signedConsentFormImageThumbnail, setSignedConsentFormImageImageThumbnail] = useState();
  const [signedConsentFormImageError, setSignedConsentFormImageError] = useState();
  const [dnReceiptImage, setDnReceiptImage] = useState();
  const [dnReceiptImageThumbnail, setDnReceiptImageThumbnail] = useState();
  const [dnReceiptImageError, setDnReceiptImageError] = useState('');
  const [objectionPopUpOpen, setObjectionPopUpOpen] = React.useState(false);
  const [arrearsEntryPopUpOpen, setArrearsEntryPopUpOpen] = React.useState(false);
  const [docVerifyAlert, setDocVerifyAlert] = React.useState(false);
  const [fieldVerifyAlert, setFieldVerifyAlert] = React.useState(false);
  const [signedConsentRejectionRemovalAlert, setSignedConsentRejectionRemovalAlert] = React.useState(false);
  const [arrearRejectionRemovalAlert, setArrearRejectionRemovalAlert] = React.useState(false);
  const [arrearsVerifyPopUpOpen, setArrearsVerifyPopUpOpen] = React.useState(false);
  const [eFileData, setEFileData] = useState([]);
  const [error, setError] = useState('')
  const [previousSecurity, setPreviousSecurity] = useState()
  const [sanctionedLoad, setSanctionedLoad] = useState()
  const [connectionCategoryType, setConnectionCategoryType] = useState()
  const [bankName, setBankName] = useState()
  const [paidDnImageDetails, setPaidDnImageDetails] = useState({
    id: null,
    applicationId: "",
    demandNoticeNo: "",
    paidDNImage: "",
    uploadedBy: "",
    uploadedAt: "",
    paymentDate: "",
    painDNImageVerification: null
  })

  // Sub Popup states
  const [documentsVerifiedSubPopUp, setDocumentsVerifiedSubPopUp] = useState(false);
  const [applicationSubittedPopUp, setApplicationSubmittedPopUp] = useState(false);
  const [arrearVerifiedSubPopUp, setArrearVerifiedSubPopUp] = useState(false);
  const [fieldSurveyedSubPopUp, setFieldSurveyedSubPopUp] = useState(false);
  const [referenceNoAllocatedSubPopUp, setReferenceNoAllocatedSubPopUp] = useState(false);
  const [dnPaymentSubmittedSubPopUp, setDnPaymentSubmittedSubPopUp] = useState(false);
  const [dnPaymentVerifiedSubPopUp, setDnPaymentVerifiedSubPopUp] = useState(false);
  const [serviceConnectionOrderedSubPopUp, setServiceConnectionOrderedSubPopUp] = useState(false);
  const [meterInstalledSubPopUp, setMeterInstalledSubPopUp] = useState(false);

  const tableColumnsProcessingSummary = [
    {
      header: 'Step Name',
      accessorKey: 'stepName',
    },
    {
      header: 'Processed By',
      accessorKey: 'processedBy',
    },
    {
      header: 'Date',
      accessorKey: 'date',
    },
    {
      header: 'Remarks',
      accessorKey: 'remarks',
    }
  ]

  const [tableDataProcessingSummary, setTableDataProcessingSummary] = useState([
    {
      stepName: 'Application Submission',
      processedBy: 'Akram',
      date: '24-Dec-2023',
      time: '02:23:19 AM',
      remarks: '-',
    },
    {
      stepName: 'Application Submission',
      processedBy: 'Akram',
      date: '24-Dec-2023',
      time: '02:23:19 AM',
      remarks: '-',
    },
    {
      stepName: 'Application Submission',
      processedBy: 'Akram',
      date: '24-Dec-2023',
      time: '02:23:19 AM',
      remarks: '-',
    },
    {
      stepName: 'Application Submission',
      processedBy: 'Akram',
      date: '24-Dec-2023',
      time: '02:23:19 AM',
      remarks: '-',
    }])

  const [arrearsDetails, setArrearsDetails] = useState({
    arrearsAmount: '',
    meterStatus: '',
    tariffDesc: '',
    meterType: '',
    phase: '',
    consumerName: '',
    consumerNo: "",
    consumerAddress: '',
    consumerEmail: '',
  });

  const [arrearsDetailsToDisplay, setArrearsDetailsToDisplay] = useState({
    refNo: '',
    arrearsAmount: '',
    meterStatus: '',
    tariffDesc: '',
    meterType: '',
    phase: '',
    consumerName: '',
    consumerNo: "",
    consumerAddress: '',
    consumerEmail: '',
    paidArearImage: '',
    paidArearDate: ''
  });

  const [consentImageDetails, setConsentImageDetails] = useState({
    consentImageChnageofTariff: '',
    consentImageChnageofTariffFlag: ''
  });

  const [consentImagePopUp, setConsentImagePopUp] = useState(false)

  const [dnDetails, setDnDetails] = useState({
    demandNoticeNo: "",
    issueDate: "",
    applicationId: "",
    dueDate: "",
    roOfficeAddress: "",
    consumerAccountNo: "",
    batchNo: "",
    tariff: "",
    bankName: "",
    industryFactoryType: null,
    connectionAccountNo: "",
    dnPaymentFlag: null,
    paymentMethod: null,
    dnPaymentVerificationFlag: null,
    previousSecurity: null,
    sanctionLoad: "",
    filledBy: null,
    filledDate: "",
    filledFlag: null,
    approvedBy: null,
    approvedDate: null,
    approvedFlag: null,
    connectionCatagoryType: null,
    dNamount: null
  });

  const [sjoDetails, setSjoDetails] = useState({
    subDivisionCode: null,
    sCONo: "",
    scoCreationDate: "",
    applicationId: "",
    applicationSubmissionDate: null,
    accountNo: null,
    feederNo: null,
    batch: null,
    applicantNewName: null,
    applicantOldTariff: null,
    applicantOldLoad: null,
    applicantNewTariff: null,
    applicantNewLoad: null,
    applicationType: null,
    mobileNo: null,
    date: null,
    materNo: null,
    cNICNo: null,
    securityDepositDNNo: null,
    dNCreationDate: null,
    ammountOfSecurityDeposit: null,
    dNPaymentDate: null,
    ammountOfCapitalCost: 0,
    capitalCostPaymentDate: null,
    filledBy: null,
    filledDate: null,
    filledFlag: null,
    approvedBy: null,
    approvedDate: null,
    approvedFlag: null
  });


  const [viewBackdrop, setViewBackdrop] = useState(false);

  const [copyOfApplicantCNICVerifyPopUp, setCopyOfApplicantCNICVerifyPopUp] = useState(false);
  const [owenershipImageVerifyPopUp, setOwenershipImageVerifyPopUp] = useState(false);
  const [otherDocumentsVerifyPopUp, setOtherDocumentsVerifyPopUp] = useState(false);
  const [authhorityLetterVerifyPopUp, setAuthhorityLetterVerifyPopUp] = useState(false);
  const [flag_applicantCNICFront, setFlag_applicantCNICFront] = useState(null)
  const [flag_applicantCNICBack, setFlag_applicantCNICBack] = useState(null)
  const [flag_owenershipImage, setFlag_owenershipImage] = useState(null)
  const [flag_otherDocuments, setFlag_OtherDocuments] = useState(null)
  const [flag_authorityLetter, setFlag_AuthorityLetter] = useState(null)
 const getWaterMarkLogo = (code) => {
    switch (code) {
      case '11':
        return LESCOWaterMark
      case '12':
        return GEPCOWaterMark
      case '13':
        return FESCOWaterMark
      case '14':
        return IESCOWaterMark
      case '15':
        return MEPCOWaterMark
      case '26':
        return PESCOWaterMark
      case '27':
        return HAZECOWaterMark
      case '37':
        return HESCOWaterMark
      case '38':
        return SEPCOWaterMark
      case '48':
        return QESCOWaterMark
      case '59':
        return TESCOWaterMark
      default:
        return MEPCOWaterMark
    }
  }
  const [foundInCOT, setFoundInCOT] = useState();
  const { state } = useLocation();
  const { foundId } = state ? state : '';
  //#endregion

  //#region formiks

  const arearsFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_property_reference_no: Yup.string().required("Enter the reference number to get arrear details.").min(14, "Enter 14 digit reference number.").max(14, "Enter 14 digit reference number."),
    }),
    onSubmit: async (values, { resetForm }) => {

      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("refNo", values.iv_property_reference_no);
      formdata.append("arrearAmount", arrearsDetails.arrearsAmount);
      formdata.append("meterStatus", arrearsDetails.meterStatus);
      formdata.append("tariff", arrearsDetails.tariffDesc);
      formdata.append("meterType", arrearsDetails.meterType);
      formdata.append("phase", arrearsDetails.phase);
      formdata.append("consumerName", arrearsDetails.consumerName);
      formdata.append("consumerPhoneNo", arrearsDetails.consumerNo);
      formdata.append("consumerEmail", arrearsDetails.consumerEmail);
      formdata.append("consumerAddress", arrearsDetails.consumerAddress);
      formdata.append("applicationNo", dialogRowData.applicationId);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "comman/insertArrear", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            if (arrearsDetails.arrearsAmount !== '') {
              callChangeObjectionStatus('Arrears Verification', 1, 'Arrears Objection')
              setArrearsEntryPopUpOpen(false)
            }
            else {
              callChangeObjectionStatus('Arrears Verification', 0, 'Arrears Objection Removed')
              callChangeProgressIdAPI(3, 'Arrears Verified', 'Arrears Verified', '', dialogRowData.applicationId)
              resetForm()
              setArrearsEntryPopUpOpen(false);
              setOpen(false)
            }
          }
          else {
            setError("Arrears objection submission failed!")
          }
        })
        .catch(() => {});
    }
  });

  const signedConsentImageFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_signed_consent_image: Yup.mixed().when('consentVerificationFlag', {
        is: () => (consentVerificationFlag === 1),
        then: Yup.mixed().required('Upload the signed consent image.'),
        otherwise: Yup.mixed().optional()
      })
    }),
    onSubmit: async (values, { resetForm }) => {
      setViewBackdrop(true)
      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("consentImageChnageofTariff", signedConsentFormImageThumbnail);
      formdata.append("applicationId", dialogRowData.applicationId);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "changeOfTariff/uploadConsentFormForChangeOfTariff", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            callChangeProgressIdAPI(dialogRowData.applicationProgressId + 1, 'Consent Uploaded', '', dialogRowData.applicationId)
          }
        })
        .catch(() => {});
      setViewBackdrop(false)
    }
  });

  const arearBillDocumentFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_arear_paid_bill_document: Yup.mixed().required('Upload arears paid bill document!'),
      iv_arear_paid_bill_date: Yup.string().required('Enter date on which arears are paid!')
    }),
    onSubmit: async (values, { resetForm }) => {

      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        "applicationId": dialogRowData.applicationId,
        "paidBillDate": values.iv_arear_paid_bill_date,
        "paidBillImage": arearPaidBillDocumentThumbnail
      });

      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "comman/updateENCArearPaidBillImage", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            callChangeObjectionStatus('Arrears Verification', 0, 'Arrears Objection Removed');
            callChangeProgressIdAPI(3, 'Arrears Verified', 'Arrears Verified', dialogRowData.applicationId)
            resetForm()
            handleClose()
          }
          else {
            setError(result.message)
          }
        })
        .catch(error => setError(error));
    }
  });

  const dnPymentReceiptFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
      iv_payment_date: Yup.date().max(new Date(), 'Payment date must be in the past!').required('Payment date is required!'),
      iv_receipt_image: Yup.mixed().required('Upload paid demand notice receipt image.')
    }),
    onSubmit: async (values, { resetForm }) => {

      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("demandNoticeNo", dnDetails.demandNoticeNo);
      formdata.append("uploadedBy", userId);
      formdata.append("paidDNImage", dnReceiptImageThumbnail);
      formdata.append("paymentMethod", "1");
      formdata.append("paymentDate", values.iv_payment_date);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "changeOfTariff/uploadPaidDNForChangeOfTariff", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            callChangeProgressIdAPI(dialogRowData.applicationProgressId + 1, 'Demand Notice Paid', 'Demand Notice Paid', dialogRowData.applicationId)
            resetForm()
            setDnReceiptImage()
            setDnReceiptImageThumbnail()
            setShowDNPayment(true)
          }
        }
        )
        .catch(() => {});
    }
  });

  const sjoFormik = useFormik({
    initialValues,
    validationSchema: Yup.object().shape({
    }),
    onSubmit: async (values, { resetForm }) => {

      var formdata = new FormData();

      formdata.append("applicationId", dialogRowData.applicationId);
      formdata.append("applicationSubmissionDate", dialogRowData.creationDate);
      formdata.append("accountNo", dialogRowData.referenceNumber);
      formdata.append("feederNo", "");
      formdata.append("batch", dialogRowData.referenceNumber.slice(0, 2));
      formdata.append("applicantNewName", dialogRowData.applicantName);
      formdata.append("applicantOldTariff", "");
      formdata.append("applicantOldLoad", dialogRowData.currentTariff);
      formdata.append("applicantNewTariff", "");
      formdata.append("applicantNewLoad", dialogRowData.newTariff);
      formdata.append("applicationType", "2");
      formdata.append("mobileNo", dialogRowData.applicantPhoneNo);
      formdata.append("date", "");
      formdata.append("materNo", "");
      formdata.append("cNICNo", dialogRowData.applicantCNIC);
      formdata.append("securityDepositDNNo", dnDetails.demandNoticeNo);
      formdata.append("dNCreationDate", dnDetails.issueDate);
      formdata.append("ammountOfSecurityDeposit", dnDetails.dNamount);
      formdata.append("dNPaymentDate", dnPaymentDate);
      formdata.append("ammountOfCapitalCost", 0);
      formdata.append("capitalCostPaymentDate", "");
      formdata.append("filledBy", userId);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;


      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "changeOfName/sjoDataInsertion", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            callSJOApproveAPI(dialogRowData.applicationId)
            resetForm()
            setOpen(false)
          }
          else {
          }
        })
        .catch(() => {});
    }
  });
  //#endregion

  //#region useEffects

  useEffect(() => {
    if (changeOfTariffApplications) {
      apiToDataGridConversionNormal()
    }
  }, [changeOfTariffApplications]);

  useEffect(() => {
    if (changeOfTariffApplicationsOverDue) {
      apiToDataGridConversionOverdue()
    }
  }, [changeOfTariffApplicationsOverDue]);

  useEffect(() => {
    if (foundId && foundId !== '') {
      setFoundInCOT(foundId)
    }
  }, [foundId])

  useLayoutEffect(() => {
    if (changeOfTariffApplications.length >= 1) {
      if (foundInCOT && foundInCOT !== '') {
        handleRowClick(foundInCOT)
      }
    }
  }, [changeOfTariffApplications])

  //#endregion

  //#region functions

  const updateDocFlag = (documentName, value) => {
    switch (documentName) {
      case 'copyOfApplicantCNIC':
        setFlag_applicantCNICFront(value);
        setFlag_applicantCNICBack(value);
        setCopyOfApplicantCNICVerifyPopUp(false);
        break;
      case 'owenershipImage':
        setFlag_owenershipImage(value);
        setOwenershipImageVerifyPopUp(false);
        break
      case 'otherDocuments':
        setFlag_OtherDocuments(value);
        setOtherDocumentsVerifyPopUp(false);
        break
      case 'authorityLetter':
        setFlag_AuthorityLetter(value);
        setAuthhorityLetterVerifyPopUp(false);
        break
      default:
        break
    }
  }

  const applicationName = (code) => {
    if (code) {
      switch (code) {
        case 1:
          return "New Connection"
        case 2:
          return "Change of Tariff"
        case 3:
          return "Change of Name"
        case 4:
          return "Change of Tariff"
        default:
          return "Application Type"
      }
    }
  }

  const updateDocumentStatus = async () => {
    if (flag_applicantCNICFront !== null && flag_applicantCNICBack !== null && flag_owenershipImage !== null && flag_otherDocuments !== null) {
      await callingUpdateDocumentStatusAPI();
    }
    else {
    }
  }

  const updateProgressIdToDocumentsVerified = async () => {

    if (flag_applicantCNICFront === 1 && flag_applicantCNICBack === 1 && flag_owenershipImage === 1) {
      // if (flag_applicantCNICFront === 1 && flag_applicantCNICBack === 1 && flag_owenershipImage === 1 && flag_otherDocuments === 1) {
      if (dialogRowData.objectionStatus === 2) {
        await callResetObjectionStatus(dialogRowData.applicationId)
      }
      await callChangeProgressIdAPI(dialogRowData.applicationProgressId + 1, "Documents Verified", "Documents Verified");

      setFlag_applicantCNICFront(null)
      setFlag_applicantCNICBack(null)
      setFlag_owenershipImage(null)
      setFlag_OtherDocuments(null)

      let arrearsDetails = await referenceApi(dialogRowData.referenceNumber)

      let arrearAmount = arrearsDetails.arrearsAmount

      if (arrearAmount != '' && parseInt(arrearAmount) > 0) {

        var formdata = new FormData();

        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;
        formdata.append("refNo", dialogRowData.referenceNumber);
        formdata.append("arrearAmount", arrearsDetails.arrearsAmount);
        formdata.append("meterStatus", arrearsDetails.meterStatus);
        formdata.append("tariff", arrearsDetails.tariffDesc);
        formdata.append("meterType", arrearsDetails.meterType);
        formdata.append("phase", arrearsDetails.phase);
        formdata.append("consumerName", arrearsDetails.consumerName);
        formdata.append("consumerPhoneNo", arrearsDetails.consumerNo);
        formdata.append("consumerEmail", arrearsDetails.consumerEmail);
        formdata.append("consumerAddress", arrearsDetails.consumerAddress);
        formdata.append("applicationNo", dialogRowData.applicationId);

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "comman/insertArrear", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === "200") {
              callChangeObjectionStatus('Arrears Verification', 1, 'Arrears Objection')
              setArrearsEntryPopUpOpen(false)
            }
            else {
            }
          })
          .catch(() => {});
      } else {
        await callChangeProgressIdAPI(3, 'Arrears Verified', 'Arrears Verified', dialogRowData.applicationId)
        setArrearsEntryPopUpOpen(false);
      }
      setViewBackdrop(false)
      setOpen(false)
    }
    else {
    }
  }

  const showRejectionRemovalAlert = () => {
    setArrearRejectionRemovalAlert(true);
  }

  const downloadDNPDF = async (applicationId) => {
    setViewBackdrop(true)
    try {
      let dnDets
      await callAsyncDnDetailsAPI(applicationId)
        .then(response => {
          dnDets = response
        });

      const getConnectionCategory = (x) => {
        if (x) {
          switch (x) {
            case 1:
              return 'Domestic';
              break
            case 2:
              return 'Commercial';
              break
            case 3:
              return 'Industrial';
              break
            default:
              return 'Others';
              break
          }
        }
      }

      let application = changeOfTariffApplications.find(item => item.applicationId === applicationId)
      const documentDiscoCode = getDocumentDiscoCode(
        applicationId,
        application.companyCode,
      );
      let officeCode = application.subDivisionCode.toString()
      let officeName = subdivisionName(parseInt(officeCode), subDivisions)
      let authorizedByName = dnDets.approvedByName ? dnDets.approvedByName : '---'
      let authorizedByDesignation = dnDets.approvedByDesignation ? dnDets.approvedByDesignation : 'Role'
      let dateToPrint = dnDets.approvedDate ? new Date(dnDets.approvedDate).toLocaleDateString() : '---'
      let stampData = printStamp(officeCode, officeName, authorizedByName, authorizedByDesignation, dateToPrint)

      const fontSize = 8
      //#region text
      const doc = new jsPDF({ compressPdf: true });

      if (dnDets.filledBy && dnDets.filledFlag) { //Upper Stamp
        doc.addImage(stampData, 'PNG', 155, 110, 55, 40); // Add image to PDF (x, y, width, height)
      }

      if (dnDets.approvedBy && dnDets.approvedFlag) { //Lower Stamp
        doc.addImage(stampData, 'PNG', 10, 180, 55, 40); // Add image to PDF (x, y, width, height)
      }


      //#region Line 1 
      var padding = 10
      var line2Height = 10
      var lineHeightIncreament = 5
      doc.setFontSize(fontSize);
      drawDnDueDate(doc, 'DUE Date: ' + dnDets.dueDate ? convertDate(dnDets.dueDate) : '-', padding, line2Height, {
      });
      doc.text(companyName(String(code) === "10" ? documentDiscoCode : applicationId.slice(0, 2)).concat(application.appliedLoad < 15 ? '(' + applicationId.slice(0, 5) + "-" + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + ')' : '(' + applicationId.slice(0, 4) + '-' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ')'), doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 2
      var line2Height = line2Height + lineHeightIncreament
      doc.text('(Department of Electricity)', doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 3
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 12
      var text1 = 'Demand Notice Serial No.: '
      var text2 = dnDets.demandNoticeNo
      var text3 = 'Application Id: '
      var text4 = applicationId
      var text5 = 'Date: '
      var text6 = convertDate(dnDets.issueDate)

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
      //#endregion

      //#region Line 4
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 3.35
      var text1 = 'Demand Notice Issuance Date: '
      var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
      var text3 = 'Application Type: '
      var text4 = application.applicationType ? applicationName(application.applicationType) : '-'
      var text5 = 'Change of Name, Reconnection etc.: '
      var text6 = application.applicationType ? applicationName(application.applicationType) : '-'

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
      //#endregion

      //#region Line 5
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 6.6
      var text1 = 'Account No. for acquisition connection: '
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
      var text3 = 'User Mobile No.: '
      var text4 = application.applicantPhoneNo ? application.applicantPhoneNo : '-'
      var text5 = 'Connection type: '
      var text6 = dnDets.connectionCatagoryType ? getConnectionCategory(dnDets.connectionCatagoryType) : '-'

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
      //#endregion

      //#region Line 6
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 7
      var text1 = '(under which the funds are to be deposited in the bank with the concerned officer of the institution)'

      doc.setFontSize(6)
      doc.text(text1, padding, line2Height);

      //#endregion

      //#region Line 7
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 22.25
      var text1 = `Department's approved Bank name: `
      var text2 = dnDets.bankName ? dnDets.bankName : '-'

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
      //#endregion

      //#region Line 9
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 16
      var text1 = 'Alloted Tariff : '
      var text2 = dnDets.tariff ? dnDets.tariff : '-'

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
      //#endregion

      //#region Line 10
      var line2Height = line2Height + lineHeightIncreament

      doc.text('DEMAND NOTICE', doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 11
      var line2Height = line2Height + lineHeightIncreament

      doc.text('(Notification of Approval Application and Demand Under Guarantee)', doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 12
      var line2Height = line2Height + lineHeightIncreament

      doc.text(`Applicant's part`, doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 13
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 16
      var text1 = `Mr. / Mrs.`
      var text2 = application.applicantName ? application.applicantName : '|'
      var text3 = `(Applicant's name)`

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      doc.setFontSize(6)
      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      //#endregion

      //#region Line 14
      lineHeightIncreament = 4
      var line2Height = line2Height + lineHeightIncreament
      doc.setFontSize(fontSize)
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
      var text1 = `You are hereby informed by demand notice that your application for change of name/load/tariff whose particulars are mentioned above has been approved by the authorized officer.`
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 15
      doc.setFontSize(fontSize)
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
      var noOfDays = '30'
      var text1 = `1. You should deposit the following amounts in the approved bank of the institution or with the concerned officer of the institution itself within [word1] days from the date of issue of this notice and inform my office with the receipt number and date of their payment.`
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[word1]", noOfDays);
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 16
      doc.setFontSize(fontSize)
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
      var noOfDays = '30'
      var text1 = `A. Expenditure service connection as per approved estimate [capitalCost] and Security [dNamount] PKR. (this amount is to be deposited with the concerned officer of the institution). If the charges are found to be more than the service approved estimate prior to connection, a deposit equal to the difference in the amount collected will be issued for which additional demand notice will be issued.`
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[capitalCost]", numberFormatting(dnDets.capitalCostAmount));
        lineText = lineText.replace("[securityCost]", numberFormatting(dnDets.securityDepositeAmount));
        lineText = lineText.replace("[bankName]", dnDets.bankName ? dnDets.bankName : '-')
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 18
      doc.setFontSize(fontSize)
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
      var noOfDays = '30'
      var text1 = `NOTE: If you are an applicant or consumer of domestic, commercial, industrial wholesale supply, you should fill the demand notice in this regard on the sub-layer (reserved for your business) and affix your signature and date on it and send back to my office.`
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 22
      doc.text(`(Irrelevant should be cut down)`, doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 23
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
      var noOfMonth = '1'
      var text1 = `If you do not comply with the above conditions in response to the demand notice within the prescribed period, your application form for change of name/load/tariff will not be considered with the serial number allotted. Demand notices thereof ( [noOfMonth] month after the date of issue) shall automatically be deemed ineffective.`
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[noOfMonth]", noOfMonth);
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 24
      doc.setFontSize(fontSize)
      var text1 = `           `
      var spaceLeft = 100
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 25
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      // var text1 = application.appliedLoad < 15 ? "Sub-Division Office " + applicationId.slice(0, 5) + '-' + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + 'SDO Wapda' : "Division Office " + applicationId.slice(0, 4) + ' - ' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ' XEN Wapda'
      var text1 = '                                                                         '
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 26
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      var text1 = 'Signature Bank Officer: '
      // var text2 = application.appliedLoad < 15 ? 'Line Superintendent Office' + '(' + applicationId.slice(0, 5) + ' - ' + subdivisionName(parseInt(applicationId.slice(0, 5)), subDivisions) + ') SDO Wapda' : 'Line Superintendent Office' + '(' + applicationId.slice(0, 4) + ' - ' + divisionName(parseInt(applicationId.slice(0, 4)), subDivisions) + ') XEN Wapda'
      var text2 = '                                                                                         '
      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 27
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      spaceLeft = 10
      doc.text('                                                                                               ', 10, line2Height)
      var line2Height = line2Height + lineHeightIncreament
      doc.text('                                                                                               ', 10, line2Height)
      var line2Height = line2Height + lineHeightIncreament
      doc.text('                                                                                               ', 10, line2Height)
      var line2Height = line2Height + lineHeightIncreament

      var text1 = '--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------'
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 28
      lineHeightIncreament = 5
      var line2Height = line2Height + lineHeightIncreament
      drawDnDueDate(doc, 'DUE Date: ' + convertDate(dnDets.dueDate), padding, line2Height, {
      });
      doc.text('For Bank Use Only', doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 29
      var line2Height = line2Height + lineHeightIncreament
      doc.text('(The concerned bank will separate this layer from the demand notice and send it to the revenue officer along with its bank scroll)', doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 30
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 16
      var spaceLeft = 50

      var text1 = `1. Applicant's Name and Complete address `
      var text2 = application.applicantName ? application.applicantName : '|'
      var text3 = `Details of paid amount`

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      doc.setFontSize(6)
      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2) + spaceLeft), line2Height);
      //#endregion

      //#region Line 31
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 6.6
      var text1 = '2. Application Id: '
      var text2 = application.applicationId ? application.applicationId : '-'
      var text3 = 'Date: '
      var text4 = application.creationDate ? convertDate(application.creationDate) : '-'
      var text5 = '1. Security:'
      var text6 = dnDets.dNamount ? numberFormatting(dnDets.dNamount) : '-'
      var leftSpace = 40

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + leftSpace + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + leftSpace, line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2) + leftSpace, line2Height + 1);
      //#endregion

      //#region Line 32
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 6.6
      var text1 = '3. Demand Notice Serial No.: '
      var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
      var text3 = 'Date: '
      var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'


      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);
      //#endregion

      //#region Line 33
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 6.6
      var text1 = '4. Account No. for acquisition connection: '
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
      var text3 = ' '
      var text4 = ' '

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
      //#endregion

      //#region Line 34
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 6.6
      var text1 = '5. Approved bank name and address:'
      var text2 = dnDets.bankName ? dnDets.bankName : '-'

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
      //#endregion

      //#region Line 35
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament + lineHeightIncreament
      var lineSpace = 6.6
      // var text1 = application.appliedLoad < 15 ? 'Signature Sub-Divisional Officer or Line Superintendent-in-charge' : 'Signature Divisional Officer or Line Superintendent-in-charge'
      var text1 = '                                                                                                                     '
      var text2 = ' '
      var text3 = ' '
      var text4 = ' '
      var text5 = ' '
      var text6 = 'Signature Bank Officer '
      var leftSpace = 20
      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
      //#endregion

      //#region Line 36
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 6.6
      var text1 = '                                     '
      var text2 = ' '
      var text3 = ' '
      var text4 = ' '
      var text5 = ' '
      var text6 = ' '
      var leftSpace = 10
      doc.setFontSize(6)
      doc.text(text1, padding, line2Height);
      //#endregion

      //#region Line 37
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament
      spaceLeft = 10
      doc.text('                                                                                               ', 10, line2Height)
      var line2Height = line2Height + lineHeightIncreament
      doc.text('                                                                                               ', 10, line2Height)
      var line2Height = line2Height + lineHeightIncreament
      doc.text('                                                                                               ', 10, line2Height)
      var line2Height = line2Height + lineHeightIncreament

      var text1 = '--------------------------------------------------------------------------------------------------------------------------------------------------------------------------------'
      doc.text(text1, padding + spaceLeft, line2Height);
      //#endregion

      //#region Line 38
      lineHeightIncreament = 4
      var line2Height = line2Height + lineHeightIncreament
      drawDnDueDate(doc, 'DUE Date: ' + convertDate(dnDets.dueDate), padding, line2Height, {
      });
      doc.text(`Applicant's Response`, doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 39
      lineHeightIncreament = 4
      var line2Height = line2Height + lineHeightIncreament
      doc.setFontSize(fontSize)
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
      var text1 = `1. I/We have submitted the security amount of [securityCost] and service connection of [capitalCost] only in the department'a approved bank [bankName] Branch by receipt no. _______ on date ________.`
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        var lineText = lines[i].replace("[capitalCost]", numberFormatting(dnDets.capitalCostAmount));
        lineText = lineText.replace("[securityCost]", numberFormatting(dnDets.securityDepositeAmount));
        lineText = lineText.replace("[bankName]", dnDets.bankName ? dnDets.bankName : '-')
        doc.text(lineText, padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 40
      doc.setFontSize(fontSize)
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
      var noOfDays = '30'
      var text1 = `2. Since I/We did not provide funds to buy meter to the institution, I am/We are responsible to pay monthly rent of ______ PKR as meter rent.`
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 41
      doc.setFontSize(fontSize)
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 2)
      var noOfDays = '30'
      var text1 = `3. I am/We are sending herewith demand notice, a certified list report from a government approved wiring contractor to prove that the internal wiring of my/our building is sound and of standard and that the installation of my/our utility equipment has been completed. I will send within the specified period..?`
      var lines = doc.splitTextToSize(text1, maxWidth);
      // Iterate through each line and add it to the PDF
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#region Line 42
      lineHeightIncreament = 5
      var line2Height = line2Height + lineHeightIncreament
      doc.text(`For Computer Center Use`, doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 43
      var line2Height = line2Height + lineHeightIncreament
      doc.text(`(Demand Notice Data)`, doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 44
      var line2Height = line2Height + lineHeightIncreament
      var lineHeightIncreament = 5
      var padding = 10
      var lineSpace = 7.5
      var text1 = 'Demand Notice Serial No.: '
      var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
      var text3 = 'Application Id: '
      var text4 = applicationId ? applicationId : '-'
      var text5 = 'Application Form No.: '
      var text6 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
      //#endregion

      //#region Line 45
      var line2Height = line2Height + lineHeightIncreament
      var lineHeightIncreament = 5
      var padding = 10
      var lineSpace = 7.5
      var text1 = 'Demand Notice Issuance Date: '
      var text2 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
      var text3 = 'Amount to be paid: '
      var text4 = dnDets.dNamount ? numberFormatting(parseInt(dnDets.dNamount)) : '-'
      var text5 = ' '
      var text6 = ' '

      doc.text(text1, padding, line2Height);
      drawDnDetailValue(doc, text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      drawDnDetailValue(doc, text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      //#endregion

      //#region Line 46
      doc.setFontSize(fontSize)
      var line2Height = line2Height + lineHeightIncreament + lineHeightIncreament / 2
      var lineSpace = 6.6
      var text1 = ' '
      var text2 = ' '
      var text3 = ' '
      var text4 = ' '
      var text5 = ' '
      // var text6 = application.appliedLoad < 15 ? 'Signature SDO with date' : 'Signature XEN with date'
      var text6 = '                             '
      var leftSpace = 110
      drawDnDetailValue(doc, text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5) + + leftSpace, line2Height);
      //#endregion

      //#region Line 47
      doc.setFontSize(6)
      lineHeightIncreament = 2
      var maxWidth = doc.internal.pageSize.getWidth() - (padding * 8)
      var text1 = 'NOTE - Computer generated demand notice, Hence no signature is required. This subject cited has been processed in accordance with documents uploaded/produced by the owner/appplicant. In case any document is found false at later stages,the said connection is likely to be cancelled and as a result of concealment of facts or fraud at any stage and if codal formalities are not followed and campany reserved its rights to take legal action against owner/applicant. '
      var lineSpace = 6.6
      var lines = doc.splitTextToSize(text1, maxWidth);
      for (var i = 0; i < lines.length; i++) {
        doc.text(lines[i], padding, line2Height);
        line2Height = line2Height + lineHeightIncreament; // Increase the y-position for the next line
      }
      //#endregion

      //#endregion

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(getWaterMarkLogo(documentDiscoCode), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
      }

      // Save the PDF
      doc.save(application.applicationId + '- Demand Notice.pdf');
    }
    catch (e) {
    }
    setViewBackdrop(false)
  }

  const hideArrearsEntryAlert = () => {
    setArrearsEntryPopUpOpen(false);
  }

  const getClassName = (x) => {
    if (x === "Pending") {
      return 'pending-button';
    }
    else if (x === "In Process") {
      return 'inprocess-button';
    }
    else if (x === "Approved") {
      return 'approved-button';
    }
    else if (x === "Objection") {
      return 'objection-button';
    }
  }

  const handleClose = () => {
    //applied load field
    setArearPaidBillUpload(false);
    setArearPaidBillDocument('');
    setArearPaidBillDocumentThumbnail('');
    arearBillDocumentFormik.values.iv_arear_paid_bill_document = '';
    arearBillDocumentFormik.values.iv_arear_paid_bill_date = '';
    sjoFormik.resetForm();
    sjoFormik.values.iv_feeder_no = '';
    sjoFormik.values.iv_cantonment_board = '';
    sjoFormik.values.iv_fgovt = '';
    sjoFormik.values.iv_pgovt = '';
    sjoFormik.values.iv_local_bodies = '';
    sjoFormik.values.iv_batch = '';
    sjoFormik.values.iv_sub_batch = '';
    sjoFormik.resetForm();
    sjoFormik.values.iv_store_requisition_no = '';
    sjoFormik.values.iv_store_requisition_date = '';
    sjoFormik.values.iv_sanctioned_load = '';
    sjoFormik.values.iv_no_of_meters = 0;
    sjoFormik.values.iv_no_of_acs = 0;
    sjoFormik.values.iv_no_of_meter_sets = 0;
    sjoFormik.values.iv_no_of_sub_sets = 0;
    sjoFormik.values.iv_no_ofsupply_points = 0;
    sjoFormik.values.iv_installed_transformer_capacity = '';
    sjoFormik.values.iv_seasonal_flag = 1;
    sjoFormik.values.iv_meter_id = '';
    sjoFormik.values.iv_meter_no = '';
    sjoFormik.values.iv_location_code = '';
    sjoFormik.values.iv_meter_code = '';
    sjoFormik.values.iv_manufacturer_code = '';
    sjoFormik.values.iv_multiplying_factor = '';
    sjoFormik.values.iv_meter_range = '';
    sjoFormik.values.iv_meter_reading = '';
    sjoFormik.values.iv_seal_on_meter = '';
    sjoFormik.values.iv_seal_on_box = '';
    sjoFormik.values.iv_connection_installer_name = '';
    sjoFormik.values.iv_date_of_connection = '';
    sjoFormik.values.iv_cp_78_item_no = '';
    sjoFormik.values.iv_security_slip_or_price_bond_no = '';
    sjoFormik.values.iv_tie_up_non_tie_up = 0;
    arearsFormik.values.iv_property_reference_no = '';
    setDnDetails({
      demandNoticeNo: "",
      issueDate: "",
      applicationId: "",
      dueDate: "",
      roOfficeAddress: "",
      consumerAccountNo: "",
      batchNo: "",
      tariff: "",
      bankName: "",
      industryFactoryType: null,
      connectionAccountNo: "",
      dnPaymentFlag: null,
      paymentMethod: null,
      dnPaymentVerificationFlag: null,
      previousSecurity: null,
      sanctionLoad: "",
      filledBy: null,
      filledDate: "",
      filledFlag: null,
      approvedBy: null,
      approvedDate: null,
      approvedFlag: null,
      connectionCatagoryType: null,
      dNamount: null
    });
    setDnReceiptImage()
    setDnReceiptImageThumbnail()
    dnPymentReceiptFormik.resetForm();
    setSjoDetails({
      subDivisionCode: null,
      sCONo: "",
      scoCreationDate: "",
      applicationId: "",
      applicationSubmissionDate: null,
      accountNo: null,
      feederNo: null,
      batch: null,
      applicantNewName: null,
      applicantOldTariff: null,
      applicantOldLoad: null,
      applicantNewTariff: null,
      applicantNewLoad: null,
      applicationType: null,
      mobileNo: null,
      date: null,
      materNo: null,
      cNICNo: null,
      securityDepositDNNo: null,
      dNCreationDate: null,
      ammountOfSecurityDeposit: null,
      dNPaymentDate: null,
      ammountOfCapitalCost: 0,
      capitalCostPaymentDate: null,
      filledBy: null,
      filledDate: null,
      filledFlag: null,
      approvedBy: null,
      approvedDate: null,
      approvedFlag: null
    });
    setDialogRowData(prevObject => ({
      ...prevObject,
      "copyOfApplicantCNIC": "",
      "owenershipImage": "",
      "previousOwnerCNIC": "",
      "perOwenerNOC": "",
      "affidaviteApplicant": "",
      "additionalCivicDocument": ""
    }));
    setFoundInCOT()
    setOpen(false);
    setEFileData([]);
    dispatch(fetchPaginatedChangeOfTariffNormal({ page: currentPageNormal, pageSize: pageSizeNormal, dateFrom: dateFromNormal, dateTo: dateToNormal, applicationProgressId: applicationProgressIdNormal, objectionStatus: objectionStatusNormal }));
  };

  const ArearPaidBillDocument = (event) => {
    arearBillDocumentFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name
      let fileNameArray = fileName.split('.')
      let extension = fileNameArray[fileNameArray.length - 1]
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize)
      if (documentValidate === 1) {
        const newFileName = "paidBillArear." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');

        const image = new Image();
        image.src = URL.createObjectURL(renamedFile);

        image.onload = () => {
          canvas.width = image.width;
          canvas.height = image.height;
          ctx.drawImage(image, 0, 0);
          const waterMarkText = getDiscoUseOnlyWatermarkText(
            getDocumentDiscoCode(
              dialogRowData?.applicationId,
              dialogRowData?.companyCode,
            ),
          );
          ctx.font = '24px Arial';
          ctx.fillStyle = 'rgba(255, 255, 255, 0.5)';
          ctx.fillText(waterMarkText, 10, canvas.height - 10);
          const watermarkedBase64 = canvas.toDataURL();
          setArearPaidBillDocument(renamedFile);
          arearBillDocumentFormik.values.iv_arear_paid_bill_document = 'uploaded';
          setArearPaidBillDocumentThumbnail(watermarkedBase64);
        }

      } else if (documentValidate === 2) {
        setArearPaidBillDocumentError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
      } else {
        setArearPaidBillDocumentError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
      }
    }
  }

  const SignedConsentFormImage = (event) => {
    signedConsentImageFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name
      let fileNameArray = fileName.split('.')
      let extension = fileNameArray[fileNameArray.length - 1]
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize)
      if (documentValidate === 1) {
        const newFileName = "signedConsentFormImage." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setSignedConsentFormImageImage(renamedFile);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Set the thumbnail image as the data URL
          const base64Image = reader.result
          setSignedConsentFormImageImageThumbnail(base64Image);
        };
      }
      else if (documentValidate === 2) {
        setSignedConsentFormImageError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
      } else {
        setSignedConsentFormImageError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
      };
    }
  }

  const DnReceiptImage = (event) => {
    dnPymentReceiptFormik.handleChange(event);
    if (event.target.files.length > 0) {
      let file = event.target.files[0];
      let fileName = file.name
      let fileNameArray = fileName.split('.')
      let extension = fileNameArray[fileNameArray.length - 1]
      const maxSize = 2 * 1024 * 1024; // 2MB in bytes
      const documentValidate = documentValidation(file, maxSize)
      if (documentValidate === 1) {
        const newFileName = "dnReceiptImage." + extension;
        const renamedFile = new File([file], newFileName, { type: file.type });
        setDnReceiptImage(renamedFile);
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
          // Set the thumbnail image as the data URL
          const base64Image = reader.result
          setDnReceiptImageThumbnail(base64Image);
        };
      }
      else if (documentValidate === 2) {
        setDnReceiptImageError("File size exceeds " + maxSize / 1024 / 1024 + "MB limit.");
      } else {
        setDnReceiptImageError("Invalid file type. Only JPG, PNG, and PDF are allowed.");
      };
    }
  }

  const apiToDataGridConversionNormal = () => {
    try {
      let tempArray = []
      if (changeOfTariffApplications) {
        changeOfTariffApplications.forEach(item => {
          let dataGridObject = {}
          if (item.applicationId) {
            dataGridObject = {
              "applicationId": item.applicationId,
              "creationDate": convertDate(item.creationDate),
              "applicantName": item.applicantName,
              "referenceno": item.referenceNumber,
              "applicationStatusId": statusFunc(item.applicationStatusId, item.objectionStatus),
              "description": item.remarks ? item.remarks : '-'
            }
            tempArray.push(dataGridObject)
          }
        })
      }
      setChangeOfTariffApplicationsToDataGrid(tempArray);
    } catch (e) {
    }
  }

  const apiToDataGridConversionOverdue = () => {
    try {
      let tempArray = []
      if (changeOfTariffApplicationsOverDue) {
        changeOfTariffApplicationsOverDue.forEach(item => {
          let dataGridObject = {}
          if (item.applicationId) {
            dataGridObject = {
              "applicationId": item.applicationId,
              "creationDate": convertDate(item.creationDate),
              "applicantName": item.applicantName,
              "referenceno": item.referenceNumber,
              "applicationStatusId": statusFunc(item.applicationStatusId, item.objectionStatus),
              "description": item.remarks ? item.remarks : '-'
            }
            tempArray.push(dataGridObject)
          }
        })
      }
      setChangeOfTariffApplicationsOverDueToDataGrid(tempArray);
    } catch (e) {
    }
  }

  const filterCOTApp = async (applicationId) => {
    const myArray = changeOfTariffApplications
    let allApplications = myArray.concat(changeOfTariffApplicationsOverDue)
    let itemFound = allApplications.find(item => item.applicationId === applicationId)
    if (itemFound === undefined) {
      itemFound = await SearchIndividualApplication(token, applicationId, '4')
    }
    return itemFound;
  }

  const handleRowClick = async (applicationId) => {
    setViewBackdrop(true)
    if (applicationId) {
      const item = await filterCOTApp(applicationId);
      if (item) {
        setFlag_applicantCNICFront(item.applicantCNICFrontFlag)
        setFlag_applicantCNICBack(item.applicantCNICBackFlag)
        setFlag_owenershipImage(item.owenershipImageFlag)
        setFlag_OtherDocuments(item.otherDocumentsFlag)
        await callEfileAPI(item.applicationId, item);
        setDialogRowData(item);

        var formdata = new FormData();
        formdata.append("applicationId", item.applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "changeOfTariff/getCOTDocuments", requestOptions)
          .then(response => response.json())
          .then(result => {
            setDialogRowData(prevObject => ({
              ...prevObject,
              applicantCNICFront: result.images[0].applicantCNICFront,
              applicantCNICBack: result.images[0].applicantCNICBack,
              owenershipImage: result.images[0].owenershipImage,
              otherDocuments: result.images[0].anyOtherDocument,
              authorityLetterImage: result.images[0].authorityLetterImage,
            }));

          })
          .catch(() => {});

        if (item.applicationProgressId === 2 && item.objectionStatus === 0) {
          let arrears = await referenceApi(item.referenceNumber)
        }

        if (item.applicationProgressId === 2 && item.objectionStatus === 1) {
          var formdata = new FormData();
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);;
          formdata.append("applicationNo", item.applicationId);
          var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
          };

          await fetch(cfpBaseUrl + "comman/getArrears", requestOptions)
            .then(response => response.json())
            .then(result => {
              const arrearsObject = {
                refNo: result.data[0].refNo,
                arrearsAmount: result.data[0].arrearAmount,
                meterStatus: result.data[0].meterStatus,
                tariffDesc: result.data[0].tariffDesc,
                meterType: result.data[0].meterType,
                phase: result.data[0].phase,
                consumerName: result.data[0].consumerName,
                consumerNo: result.data[0].consumerPhoneNo,
                consumerAddress: result.data[0].consumerAddress,
                consumerEmail: result.data[0].consumerEmail,
                paidArearImage: result.data[0].paidArearImage,
                paidArearDate: result.data[0].paidArearDate
              }
              arearsFormik.values.iv_property_reference_no = result.data[0].refNo
              setArrearsDetailsToDisplay(arrearsObject);
            })
            .catch(() => {});
        }

        if (item.applicationProgressId === 4) {
          await callAsyncGetConsentImage(item.applicationId)
          await callBillingToGetPreviousSecurity(item.referenceNumber)
        }

        if (item.applicationProgressId >= 5) {

          var formdata = new FormData();
          formdata.append("applicationId", item.applicationId);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);;

          var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
          };

          await fetch(cfpBaseUrl + "changeOfTariff/getDNForChangeOfTariff", requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result.data.length > 0) { // if field survey data is already filled
                setDnDetails(result.data[0])
              }
            })
            .catch(() => {});
        }

        if (item.applicationProgressId >= 6) {
          var formdata = new FormData();
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);;
          formdata.append("applicationId", item.applicationId);

          var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
          };

          await fetch(cfpBaseUrl + "changeOfTariff/getPaidDNForChangeOfTariff", requestOptions)
            .then(response => response.json())
            .then(result => {
              if (result.status === "200") {
                setDnImage(result.data[0].paidDNImage)
                setDnPaymentDate(result.data[0].paymentDate)
              }
            })
            .catch(() => {});
        }

        if (item.applicationProgressId >= 7) {
          var formdata = new FormData();
          formdata.append("applicationId", item.applicationId);
          const myHeaders = new Headers();
          myHeaders.append("Authorization", token);;

          var requestOptions = {
            method: 'POST',
            body: formdata,
            headers: myHeaders,
            redirect: 'follow',
          };

          await fetch(cfpBaseUrl + "changeOfTariff/getDNForChangeOfTariff", requestOptions)
            .then(response => response.json())
            .then(result => {
              setDnDetails(result.data[0])
              sjoFormik.values.iv_batch = result.data[0].batchNo
              if (item.areaType === "Urban" || item.areaType === "Urban") {
                sjoFormik.values.iv_rural_urban = 'U'
              }
              else if (item.areaType === "Rural" || item.areaType === "rural") {
                sjoFormik.values.iv_rural_urban = 'R'
              }
            })
            .catch(() => {});

          callGetSJOAPI(item.applicationId)
        }

        setViewBackdrop(false)
        setOpen(true);
      }
    }
  };

  const showArrearsEntryPopup = async () => {
    await referenceApi();
    setArrearsEntryPopUpOpen(true);
  }

  const downloadSJOPDF = async (applicationId, applicationType) => {
    setViewBackdrop(true)
    try {
      let scoDets

      await callAsyncGetSJOAPI(applicationId)
        .then(response => {
          scoDets = response
        });

      let dnDets
      await callAsyncDnDetailsAPI(applicationId)
        .then(response => {
          dnDets = response
        });

      let application = changeOfTariffApplications.find(item => item.applicationId === applicationId)
      const documentDiscoCode = getDocumentDiscoCode(
        applicationId,
        application.companyCode,
      );
      let officeCode = application.subDivisionCode.toString()
      let officeName = subdivisionName(parseInt(officeCode), subDivisions)
      let authorizedByName = scoDets.approvedByName ? scoDets.approvedByName : '---'
      let authorizedByDesignation = scoDets.approvedByDesignation ? scoDets.approvedByDesignation : 'Role'
      let dateToPrint = scoDets.approvedDate ? new Date(scoDets.approvedDate).toLocaleDateString() : '---'
      let stampData = printStamp(officeCode, officeName, authorizedByName, authorizedByDesignation, dateToPrint)

      const fontSize = 9

      //#region text

      const doc = new jsPDF({ compressPdf: true });


      if (scoDets.approvedBy && scoDets.approvedFlag) { //Lower Stamp
        doc.addImage(stampData, 'PNG', 160, 70, 55, 40); // Add image to PDF (x, y, width, height)
      }

      //#region Line 1 
      var padding = 10
      var line2Height = 10
      var lineHeightIncreament = 6
      doc.setFontSize(fontSize);
      doc.text(companyName(String(code) === "10" ? documentDiscoCode : applicationId.slice(0, 2)), doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 2
      var line2Height = line2Height + lineHeightIncreament
      doc.text('Service Connection Order ' + applicationType, doc.internal.pageSize.getWidth() / 2, line2Height, {
        align: 'center',
      });
      //#endregion

      //#region Line 3
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 10
      var text1 = '1. Sub Division: '
      var text2 = application.subDivisionCode ? application.subDivisionCode.toString().concat(' / ').concat(subdivisionName(application.subDivisionCode, subDivisions)) : '-'
      var text3 = 'SCO No.: '
      var text4 = scoDets.sCONo ? scoDets.sCONo.toString() : '-'
      var text5 = 'Creation Date: '
      var text6 = scoDets.scoCreationDate ? convertDate(scoDets.scoCreationDate) : '-'

      doc.text(text1, padding, line2Height);
      doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
      //#endregion

      //#region Line 4
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 2
      var text1 = '2. Application No.: '
      var text2 = application.applicationId ? application.applicationId : '-'
      var text3 = 'Date: '
      var text4 = application.creationDate ? convertDate(application.creationDate) : '-'


      doc.text(text1, padding, line2Height);
      doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);


      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);
      //#endregion

      //#region Line 5
      var line2Height = line2Height + lineHeightIncreament
      var lineSpace = 10
      var text1 = '3. Account No.: '
      var text2 = dnDets.connectionAccountNo ? dnDets.connectionAccountNo : '-'
      var text3 = 'Feeder No.: '
      var text4 = scoDets.feederNo ? scoDets.feederNo : '-'
      var text5 = 'Batch: '
      var text6 = application.referenceNumber ? application.referenceNumber.slice(0, 2) : '-'


      doc.text(text1, padding, line2Height);
      doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
      doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

      doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height);
      doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2), line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height + 1);

      doc.text(text5, (doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)), line2Height);
      doc.text(text6, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 5), line2Height);
      doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4), line2Height + 1, doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + doc.getTextWidth(text4) + doc.getTextWidth(text5) + padding + (lineSpace * 4) + doc.getTextWidth(text6) + (lineSpace * 2), line2Height + 1);

      //#endregion

      if (applicationType === 'Change of Name') {

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `4. Applicant's Name: `
        var text2 = application.applicantName ? application.applicantName : '-'
        var text3 = 'CNIC/NIC/NICOP: '
        var text4 = application.applicantCNIC ? application.applicantCNIC : '-'
        var leftSpace = 50

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `5. Applicant Phone: `
        var text2 = application.applicantPhoneNo ? application.applicantPhoneNo : '-'
        var text3 = 'Applicant Email: '
        var text4 = application.applicantEmail ? application.applicantEmail : '-'
        var leftSpace = 50

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `6. Applicant Father Name: `
        var text2 = application.newFatherName ? application.newFatherName : '-'


        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //#endregion

        //#region Line 9
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `7. Old Name: `
        var text2 = application.currentName ? application.currentName : '-'
        var text3 = 'CNIC/NIC/NICOP: '
        var text4 = application.currentCNIC ? application.currentCNIC : '-'
        var leftSpace = 50

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `8. Old Phone: `
        var text2 = application.currentPhone ? application.currentPhone : '-'
        var text3 = 'Old Email: '
        var text4 = application.currentEmail ? application.currentEmail : '-'
        var leftSpace = 50

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `9. Old Father Name: `
        var text2 = application.currentFatherName ? application.currentFatherName : '-'


        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `10. Security Deposit DN No.: `
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
        var text3 = 'Issuance Date: '
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
        var leftSpace = 47

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `11. Amount of Security: `
        var text2 = dnDets.dNamount ? numberFormatting(dnDets.dNamount) : '-'
        var text3 = 'Payment Date: '
        var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
        var leftSpace = 52

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 14
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `12. Authorized By (Name): `
        var text2 = scoDets.approvedByName ? scoDets.approvedByName : '-'
        var text3 = '                                    '
        var leftSpace = 62

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //#endregion

        //#region Line 15
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = '                 '
        var text2 = '                '
        var leftSpace = 122

        doc.text(text1, padding + leftSpace, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 16
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = '                                   '
        var leftSpace = 122

        doc.text(text1, padding + leftSpace, line2Height);
        //#endregion

        //#region Line 17
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = '                                   '
        var leftSpace = 122

        doc.text(text1, padding + leftSpace, line2Height);
        //#endregion

      }

      if (applicationType === 'Change of Load') {

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `4. Applicant's Name: `
        var text2 = application.applicantName ? application.applicantName : '-'
        var text3 = 'CNIC/NIC/NICOP: '
        var text4 = application.applicantCNIC ? application.applicantCNIC : '-'
        var leftSpace = 50

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + lineSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `5. Applicant Phone: `
        var text2 = application.applicantPhoneNo ? application.applicantPhoneNo : '-'

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `6. Old Load: `
        var text2 = application.currentSanctionedLoad ? application.currentSanctionedLoad.toString() : '-'
        var text3 = 'New Load: '
        var text4 = application.newSanctionedLoad ? application.newSanctionedLoad.toString() : '-'
        var leftSpace = 50

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 9
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `7. Security Deposit DN No.: `
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
        var text3 = 'Issuance Date: '
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
        var leftSpace = 47

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `8. Amount of Security: `
        var text2 = dnDets.dNamount ? numberFormatting(dnDets.dNamount) : '-'
        var text3 = 'Payment Date: '
        var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
        var leftSpace = 52

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `9. Authorized By (Name): `
        var text2 = scoDets.approvedByName ? scoDets.approvedByName : '-'
        var text3 = '                                           '
        var leftSpace = 62

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //#endregion

        //#region Line 12
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = '                                            '
        var text2 = '                                          '
        var leftSpace = 122

        doc.text(text1, padding + leftSpace, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 13
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = 'Designation: __________________________'
        var leftSpace = 122

        doc.text(text1, padding + leftSpace, line2Height);
        //#endregion

        //#region Line 14
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = 'Stamp: ______________________________'
        var leftSpace = 122

        doc.text(text1, padding + leftSpace, line2Height);
        //#endregion

        //#region Line 15
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = 'UserName: '

        doc.text(text1, padding, line2Height);
        doc.text(userId, padding + doc.getTextWidth(text1), line2Height);
        //#endregion

      }

      if (applicationType === 'Change of Tariff') {

        //#region Line 6
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `4. Applicant's Name: `
        var text2 = application.applicantName ? application.applicantName : '-'
        var text3 = 'CNIC/NIC/NICOP: '
        var text4 = application.applicantCNIC ? application.applicantCNIC : '-'
        var leftSpace = 20

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 7
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `5. Applicant Phone: `
        var text2 = application.applicantPhoneNo ? application.applicantPhoneNo : '-'

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        //#endregion

        //#region Line 8
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `6. Old Tariff: `
        var text2 = application.currentTariff ? application.currentTariff : '-'
        var text3 = 'New Tariff: '
        var text4 = application.newTariff ? application.newTariff : '-'
        var leftSpace = 20

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 9
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `7. Security Deposit DN No.: `
        var text2 = dnDets.demandNoticeNo ? dnDets.demandNoticeNo : '-'
        var text3 = 'Issuance Date: '
        var text4 = dnDets.issueDate ? convertDate(dnDets.issueDate) : '-'
        var leftSpace = 47

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 10
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `8. Amount of Security: `
        var text2 = dnDets.dNamount ? numberFormatting(dnDets.dNamount) : '-'
        var text3 = 'Payment Date: '
        var text4 = dnDets.paymentDate ? convertDate(dnDets.paymentDate) : '-'
        var leftSpace = 52

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        doc.text(text4, doc.getTextWidth(text2) + doc.getTextWidth(text1) + doc.getTextWidth(text3) + padding + (lineSpace * 3) + leftSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2) + leftSpace, line2Height + 1, (doc.getTextWidth(text1) + doc.getTextWidth(text2) + doc.getTextWidth(text3) + padding + (lineSpace * 2)) + (doc.getTextWidth(text4) + (lineSpace * 2)) + leftSpace, line2Height + 1);
        //#endregion

        //#region Line 11
        var line2Height = line2Height + lineHeightIncreament
        var lineSpace = 10
        var text1 = `9. Authorized By (Name): `
        var text2 = scoDets.approvedByName ? scoDets.approvedByName : '-'
        var text3 = '                                 '
        var leftSpace = 62

        doc.text(text1, padding, line2Height);
        doc.text(text2, doc.getTextWidth(text1) + padding + lineSpace, line2Height);
        doc.line(doc.getTextWidth(text1) + padding, line2Height + 1, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)), line2Height + 1);

        doc.text(text3, (doc.getTextWidth(text1) + padding) + (doc.getTextWidth(text2) + (lineSpace * 2)) + leftSpace, line2Height);
        //#endregion
      }

      //#endregion

      const totalPages = doc.internal.getNumberOfPages();

      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);
        doc.addImage(getWaterMarkLogo(documentDiscoCode), 'PNG', 0, 0, doc.internal.pageSize.getWidth(), doc.internal.pageSize.getHeight());
      }

      // Save the PDF
      doc.save(applicationId + '- SJO.pdf');
    }
    catch (e) {
    }
    setViewBackdrop(false)
  }

  const hideArrearRejectionRemovalAlert = () => {
    setArearPaidBillDocument('');
    setArearPaidBillDocumentThumbnail('');
    arearBillDocumentFormik.resetForm();
    setArrearRejectionRemovalAlert(false);
  }

  const hideSignedConsentRejectionRemovalAlert = () => {
    setSignedConsentRejectionRemovalAlert(false);
    setSignedConsentFormImageImage('');
    setConsentVerificationFlag(0);
    setSignedConsentFormImageImageThumbnail('');
  }

  const hideDnPaymentVerifyAlert = () => {
    setDnPaymentVerifyAlert(false);
  }

  const openDetailsPopUp = async (stepName) => {
    let id = dialogRowData.applicationId
    if (stepName === "Application Submitted" || stepName === "APPLICATION SUBMITTED") {
      setApplicationSubmittedPopUp(true)
    }
    else if (stepName === "Documents Verified" || stepName === "DOCUMENT VERIFICATION") {
      setDocumentsVerifiedSubPopUp(true)
    }
    else if (stepName === "Arrears Verified" || stepName === "ARREAR VERIFICATION") {
      setArrearVerifiedSubPopUp(true)
    }
    else if (stepName === "Consent Uploaded" || stepName === "SITE SURVEY") {
      await callAsyncGetConsentImage(dialogRowData.applicationId)
      setFieldSurveyedSubPopUp(true)
    }
    else if (stepName === "Demand Note Issued" || stepName === "SIGNED CONSENT VALIDATION") {
      await callAsyncDnDetailsAPI(dialogRowData.applicationId)
      setReferenceNoAllocatedSubPopUp(true)
    }
    else if (stepName === "DN Payment Submitted" || stepName === "DN PAYMENT SUBMISSION") {
      await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId)
      setDnPaymentSubmittedSubPopUp(true)
    }
    else if (stepName === "DN Payment Verified" || stepName === "DN PAYMENT VERIFICATION") {
      // await callAsyncGetPaidDnImageAPI(dialogRowData.applicationId)
      setDnPaymentVerifiedSubPopUp(true)
    }
    else if (stepName === "Service Connection Ordered" || stepName === "SERVICE CONNECTION ORDER") {
      await callAsyncGetSJOAPI(dialogRowData.applicationId)
      setServiceConnectionOrderedSubPopUp(true)
    }
  }

  const hideCopyOfApplicantCNICVerifyAlert = (x) => {
    setCopyOfApplicantCNICVerifyPopUp(x);
  }

  const hideOtherDocumentsVerifyAlert = (x) => {
    setOtherDocumentsVerifyPopUp(x);
  }

  const hideAuthorityLetterVerifyAlert = (x) => {
    setAuthhorityLetterVerifyPopUp(x);
  }

  const hidePropertyDocVerifyAlert = (x) => {
    setOwenershipImageVerifyPopUp(x);
  }

  const hideConsentImagePopUp = () => {
    setConsentImagePopUp(false)
  }

  const hidePaidDnImagePopUp = (x) => {
    setPaidDNImagePopUp(x);
  }

  const stepName = (x) => {
    if (x === 0) {
      return 'Application Submitted'
    }
    else if (x === 1) {
      return 'Documents Submitted'
    }
    else if (x === 2) {
      return 'Documents Verified'
    }
    else if (x === 3) {
      return 'Arrears Verified'
    }
    else if (x === 4) {
      return 'Consent Uploaded'
    }
    else if (x === 5) {
      return 'Demand Note Issued'
    }
    else if (x === 6) {
      return 'DN Payment Submitted'
    }
    else if (x === 7) {
      return 'DN Payment Verified'
    }
    else if (x === 8) {
      return 'Service Connection Ordered'
    }
  };

  useScanDetection({
    onComplete: async (code) => {
      if (code) {
        code = code.replace(/Shift/g, '');
        const regex = /^[A-Z]{2}-\d{14,15}$/;
        if (regex.test(code)) {
          await handleRowClick(code);
        } else {
        }
      }
    },
    minLength: 4, // EAN13
  });

  //#endregion

  //#region API Functions

  const callResetObjectionStatus = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);;

    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    };

    fetch(cfpBaseUrl + "changeOfTariff/resetObjectionStatus", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status === '200') {
          // let lclStrdCotApp = JSON.parse(window.localStorage.getItem('change-of-tariff-applications'));
          // const index = lclStrdCotApp.findIndex(item => item.applicationId === applicationId);
          // lclStrdCotApp[index].objectionStatus = 0
          // window.localStorage.setItem('change-of-tariff-applications', JSON.stringify(lclStrdCotApp));
          // setChangeOfTariffApplications(JSON.parse(window.localStorage.getItem('change-of-tariff-applications')));
          // setDialogRowData(lclStrdCotApp[index])
          handleClose()
        }
        else {
        }
      })
      .catch(() => {});

  }

  const callingUpdateDocumentStatusAPI = async () => {
    var formdata = new FormData();
    formdata.append("applicationNo", dialogRowData.applicationId);
    formdata.append("applicantCNICFrontFlag", flag_applicantCNICFront);
    formdata.append("applicantCNICBackFlag", flag_applicantCNICBack);
    formdata.append("owenershipImageFlag", flag_owenershipImage);
    formdata.append("otherDocumentsFlag", flag_otherDocuments);
    formdata.append("authorityLetterFlag", flag_authorityLetter);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);;

    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    };

    await fetch(cfpBaseUrl + "changeOfTariff/updateCOTDocumentFlag", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status === '200') {
          let remarksToSave = 'Documents Objections in: '
          if (
            flag_applicantCNICFront === -1 ||
            flag_applicantCNICBack === -1 ||
            flag_owenershipImage === -1 ||
            flag_otherDocuments === -1
          ) {

            if (flag_applicantCNICFront === -1 || flag_applicantCNICBack === -1) {
              remarksToSave = remarksToSave + "Applicant CNIC, "
            }
            if (flag_owenershipImage === -1) {
              remarksToSave = remarksToSave + "Premises Document, "
            }
            if (flag_otherDocuments === -1) {
              remarksToSave = remarksToSave + "Additional Tariff Document, "
            }

            callChangeObjectionStatus('Document Verification', 1, remarksToSave);

            // let lclStrdCotApp = JSON.parse(window.localStorage.getItem('change-of-tariff-applications'));
            // const index = lclStrdCotApp.findIndex(item => item.applicationId === dialogRowData.applicationId);
            // lclStrdCotApp[index].applicantCNICFrontFlag = flag_applicantCNICFront
            // lclStrdCotApp[index].applicantCNICBackFlag = flag_applicantCNICBack
            // lclStrdCotApp[index].owenershipImageFlag = flag_owenershipImage
            // lclStrdCotApp[index].otherDocumentsFlag = flag_otherDocuments
            // window.localStorage.setItem('change-of-tariff-applications', JSON.stringify(lclStrdCotApp));
            // setChangeOfTariffApplications(JSON.parse(window.localStorage.getItem('change-of-tariff-applications')));
            setFlag_applicantCNICFront(null)
            setFlag_applicantCNICBack(null)
            setFlag_owenershipImage(null)
            setFlag_OtherDocuments(null)
          }
          else {
            updateProgressIdToDocumentsVerified()
          }
        }
        else {
        }
      })
      .catch(() => {});
  }

  const callChangeProgressIdAPI = async (applicationProgressId, remarks, remarksDetails = '-', id = dialogRowData.applicationId) => {
    var formdata = new FormData();

    formdata.append("applicationId", id);
    formdata.append("applicationProgressId", applicationProgressId);
    formdata.append("remarks", remarks);
    formdata.append("remarksDetails", remarksDetails);
    formdata.append("lastModifiedBy", userId);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);;

    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    };

    await fetch(cfpBaseUrl + "comman/changeProgressId", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status === '200') {
          // let lclStrdCotApp = JSON.parse(window.localStorage.getItem('change-of-tariff-applications'));
          // const index = lclStrdCotApp.findIndex(item => item.applicationId === id);
          // lclStrdCotApp[index].applicationProgressId = applicationProgressId
          // window.localStorage.setItem('change-of-tariff-applications', JSON.stringify(lclStrdCotApp));
          // setChangeOfTariffApplications(JSON.parse(window.localStorage.getItem('change-of-tariff-applications')));
          handleClose();
        }
        else {
        }
      })
      .catch(() => {});

    setDocVerifyAlert(false);
    setArrearsVerifyPopUpOpen(false);
    setFieldVerifyAlert(false);
    setOpen(false);
  }

  const callChangeObjectionStatus = async (step, objectionStatus, remarks, remarksDetails = '-') => {
    var formdata = new FormData();
    formdata.append("applicationId", dialogRowData.applicationId);
    formdata.append("objectionStatus", objectionStatus);
    formdata.append("remarks", remarks);
    formdata.append("remarksDetails", remarksDetails);
    formdata.append("lastModifiedBy", userId);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);;

    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    };

    await fetch(cfpBaseUrl + "comman/changeObjectionStatus", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status === '200') {
          handleClose();
        }
        else {
        }
      })
      .catch(() => {});
    setArrearRejectionRemovalAlert(false);
    setObjectionPopUpOpen(false);
  }

  const referenceApi = async (referenceNo = dialogRowData.referenceNumber) => {
    setViewBackdrop(true)
    let arrearDetailsObj = {
      arrearsAmount: '',
      meterStatus: '',
      tariffDesc: '',
      meterType: '',
      phase: '',
      consumerName: '',
      consumerNo: "",
      consumerAddress: '',
      consumerEmail: '',
    }

    try {
      let apiResponse = await dBillAPI(token, referenceNo)
      if (apiResponse.status) {
        let basicInfo = apiResponse.basicInfo;
        if (basicInfo.arrear != '') {
          setNoArrears('');
          arrearDetailsObj.arrearsAmount = numberFormatting(basicInfo.arrear)
          arrearDetailsObj.meterStatus = basicInfo.meter1Status
          arrearDetailsObj.tariffDesc = basicInfo.tariffDescription
          arrearDetailsObj.meterType = basicInfo.meterType
          arrearDetailsObj.phase = basicInfo.phase
          arrearDetailsObj.consumerName = basicInfo.consumerName
          arrearDetailsObj.consumerNo = basicInfo.consumerContactNo
          arrearDetailsObj.consumerAddress = basicInfo.consumerAddress1 + ' ' + basicInfo.consumerAddress2
          arrearDetailsObj.consumerEmail = basicInfo.consumerEmail
          setArrearsDetails(arrearDetailsObj);
        }
        else {
          setArrearsDetails(arrearDetailsObj);
          setNoArrears('No arrears exist for entered reference number.');
        }
      }
      setViewBackdrop(false)
      return arrearDetailsObj
    }
    catch (e) {
    }
  };

  const callAsyncDnDetailsAPI = async (applicationId) => {
    try {

      let dnDets = {}

      var formdata = new FormData();
      formdata.append("applicationId", applicationId);
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "changeOfTariff/getDNForChangeOfTariff", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            dnDets = result.data[0]
          }
        }).catch(() => {});
      return dnDets
    }
    catch (e) {
    }
  }

  const callGetSJOAPI = async (applicationId) => {
    try {
      if (applicationId) {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "changeOfName/getSJO", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === "200") {
              setSjoDetails(
                result.data[0]
              )
            }
            else {
            }
          })
          .catch(() => {});
      }

    }
    catch (e) {
    }
  }

  const callSJOCreationAPI = async (applicationId) => {
    if (applicationId) {
      var formdata = new FormData();
      formdata.append("paidDNImageVerifiedBy", userId);
      formdata.append("applicationId", applicationId);
      formdata.append("subDivisionCode", dialogRowData.referenceNumber.slice(2, 7));
      formdata.append("changeofAttributeTypeId", '3');
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "changeOfName/sjoCreation", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            callChangeProgressIdAPI(dialogRowData.applicationProgressId + 1, "DN Payment Verified", '', dialogRowData.applicationID)
          }
          else {
          }
        })
        .catch(error => {
        });
    }
  }

  const callAsyncResetDocsFlags = async (applicationId = dialogRowData.applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationNo", applicationId);
    formdata.append("applicantCNICFrontFlag", "");
    formdata.append("applicantCNICBackFlag", "");
    formdata.append("owenershipImageFlag", "");
    formdata.append("otherDocumentsFlag", "");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);;

    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    };

    await fetch(cfpBaseUrl + "changeOfTariff/updateCOTDocumentFlag", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status === "200") {
          let allApplications = changeOfTariffApplications
          let index = changeOfTariffApplications.findIndex((item) => item.applicationId === applicationId)
          allApplications[index].applicantCNICFrontFlag = null
          allApplications[index].applicantCNICBackFlag = null
          allApplications[index].owenershipImageFlag = null
          allApplications[index].otherDocumentsFlag = null
          window.localStorage.setItem('change-of-tariff-applications', JSON.stringify(allApplications))
        }
        else {
        }
      })
      .catch(() => {});
  }

  const callAsyncGetConsentImage = async (applicationId = dialogRowData.applicationId) => {
    try {
      var formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("applicationId", applicationId);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "changeOfTariff/getConsentFormForChangeOfTariff", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            setConsentImageDetails(result.data[0]);
          }
        })
        .catch(() => {});
    }
    catch (e) {
    }
  }

  const callBillingToGetPreviousSecurity = async (referenceNo = dialogRowData.referenceNumber) => {
    try {
      let apiResponse = await dBillAPI(token, referenceNo)
      if (apiResponse.status) {
        let basicInfo = apiResponse.basicInfo
        let previousSecurity = basicInfo.sec_amnt
        let sanctionedLoad = basicInfo.sactionLoad
        let connectionCatagoryType = basicInfo.cons_cat
        if (connectionCatagoryType === 'DOMESTIC' || connectionCatagoryType === 'DOMMESTIC') {
          setConnectionCategoryType(1)
        } else if (connectionCatagoryType === 'COMMERCIAL') {
          setConnectionCategoryType(2)
        } else if (connectionCatagoryType === 'INDUSTRIAL') {
          setConnectionCategoryType(3)
        }
        setPreviousSecurity(previousSecurity)
        setSanctionedLoad(sanctionedLoad)
        if (sanctionedLoad < 15) {
          let subDivisionObject = subDivisions.find((objs) => objs.subDivisionCode === parseInt(referenceNo.slice(2, 7)))
          if (subDivisionObject) {
            setBankName(subDivisionObject.subDivBankName)
          }
        }
        else if (sanctionedLoad >= 15 && sanctionedLoad <= 70) {
          let divisionObject = subDivisions.find((objs) => objs.divisionCode === parseInt(referenceNo.slice(2, 6)))
          if (divisionObject) {
            setBankName(divisionObject.divBankName)
          }
        }
      }
      else {
        setError('Reference No. not found!')
      }
    }
    catch (e) {
    }
  }

  const callAsyncCreateDnForChangeOfTariff = async (applicationId = dialogRowData.applicationId) => {
    try {

      var formdata = new FormData();

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);;
      formdata.append("applicationId", applicationId);
      formdata.append("previousSecurity", previousSecurity ? previousSecurity : 0);
      formdata.append("sanctionLoad", sanctionedLoad ? sanctionedLoad : 1);
      formdata.append("connectionCatagoryType", connectionCategoryType ? connectionCategoryType : 1);
      formdata.append("roOfficeAddress", divisionName(parseInt(dialogRowData.referenceNumber.slice(2, 6)), subDivisions));
      formdata.append("consumerAccountNo", dialogRowData.referenceNumber.slice(5,));
      formdata.append("batchNo", dialogRowData.referenceNumber.slice(0, 2));
      formdata.append("oldTariff", dialogRowData.currentTariff);
      formdata.append("newTariff", dialogRowData.newTariff);
      formdata.append("bankName", bankName);
      formdata.append("connectionAccountNo", dialogRowData.referenceNumber);
      formdata.append("filledBy", userId);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      await fetch(cfpBaseUrl + "changeOfTariff/createDNforChangeOfTariff", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            callChangeProgressIdAPI(dialogRowData.applicationProgressId + 1, 'Demand Note Issued', '-', dialogRowData.applicationId)
          }
        }).catch(() => {});
    }
    catch (e) {
    }
  }

  const callSJOApproveAPI = async (applicationId) => {
    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    formdata.append("approvedBy", userId);
    formdata.append("approvedFlag", 1);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);;

    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    };

    await fetch(cfpBaseUrl + "changeOfName/sjoApproval", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status === "200") {
          callChangeProgressIdAPI(dialogRowData.applicationProgressId + 1, 'Service Connection Order Approved', "Service Connection Order Approved")
        }
        else {
        }
      })
      .catch(() => {});
  }

  const callAsyncGetSJOAPI = async (applicationId) => {
    try {
      let sjoDets = {}
      if (applicationId) {
        var formdata = new FormData();
        formdata.append("applicationId", applicationId);
        const myHeaders = new Headers();
        myHeaders.append("Authorization", token);;

        var requestOptions = {
          method: 'POST',
          body: formdata,
          headers: myHeaders,
          redirect: 'follow',
        };

        await fetch(cfpBaseUrl + "changeOfName/getSJO", requestOptions)
          .then(response => response.json())
          .then(result => {
            if (result.status === "200") {
              sjoDets = result.data[0]
            }
          })
          .catch(() => {});
        return sjoDets
      }
    }
    catch (e) {
    }
  };

  const callEfileAPI = async (applicationId, application) => {

    // let application = changeOfTariffApplications.find((item) => { return item.applicationId === applicationId })

    var formdata = new FormData();
    formdata.append("applicationId", applicationId);
    const myHeaders = new Headers();
    myHeaders.append("Authorization", token);;

    var requestOptions = {
      method: 'POST',
      body: formdata,
      headers: myHeaders,
      redirect: 'follow',
    };

    await fetch(cfpBaseUrl + "changeOfTariff/getChangeOfTariffHistory", requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.status === "200") {
          let applicationCurrentState = result.applicationCurrentState[0]
          let applicationHistory = result.applicationHistory
          if (applicationHistory === "No History Found") {
            applicationHistory = []
          }

          applicationHistory.push(applicationCurrentState)
          let sortedApplicationHistory = applicationHistory.sort((a, b) => {
            const dateA = new Date(a.lastModificationDate)
            const dateB = new Date(b.lastModificationDate)
            return dateB - dateA
          });

          setEFileData(sortedApplicationHistory)

          let dataforTable = []

          sortedApplicationHistory.forEach(item => {
            if (item.applicationProgressId !== 0 && item.lastModifiedBy && item.lastModificationDate) {
              let object = {}
              object.stepName = stepName(item.applicationProgressId)
              object.processedBy = item.lastModifiedBy ? item.lastModifiedBy : 'Last Modified By Name'
              object.date = item.lastModificationDate ? convertDatewithTime(item.lastModificationDate) : 'Last Modification Time'
              object.remarks = item.remarks ? item.remarks : '-'
              dataforTable.push(object)
            }
          })

          dataforTable.push({
            date: convertDate(application.creationDate),
            processedBy: application.applicantName,
            stepName: "Application Submitted",
            time: convertDatewithTime(application.creationDate).slice(11, 17),
            remarks: '-'
          })

          setTableDataProcessingSummary(dataforTable);
        }
        else {
        }
      })
      .catch(() => {});
  }

  const callAsyncGetPaidDnImageAPI = async (applicationId) => {
    try {
      let dnImage = ''
      var formdata = new FormData();

      formdata.append("applicationNo", applicationId);
      formdata.append("demandNoticeNo", '');

      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      var requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow'
      };

      await fetch(cfpBaseUrl + "demandNotice/getPaidDNImage", requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.status === "200") {
            setPaidDnImageDetails(result.data[0])
            dnImage = result.data[0].paidDNImage
          }
        })
        .catch(() => {});
      return dnImage
    }
    catch (e) {
    }
  }

  //#endregion

  const tblColumns = [
    { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    { field: "creationDate", type: 'date', headerName: 'Submission Date', align: 'center', sortable: false, filterable: true, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    { field: "applicantName", type: 'text', headerName: 'Applicant Name', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    { field: "referenceno", type: 'text', headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle },
    {
      field: "applicationStatusId",
      headerStyle: tableStyle.headerStyle,
      headerCellStyle: tableStyle.headerCellStyle,
      rowCellStyle: tableStyle.rowCellStyle,
      headerName: "Status",
      align: 'center',
      sortable: false,
      filterable: true,
      type: 'singleSelect',
      valueOptions: ['Pending', 'In Process', 'Approved', 'Completed', 'Objection'],
      renderCell: (params) => {
        let btnText = (params.applicationStatusId)
        return (
          <div className={getClassName(btnText)} >{btnText}</div>
        )
      }
    },
    { field: "description", type: 'dateTime', headerName: 'Description', align: 'center', sortable: false, filterable: false, headerStyle: tableStyle.headerStyle, headerCellStyle: tableStyle.headerCellStyle, rowCellStyle: tableStyle.rowCellStyle }
  ]

  const tblColumnsOverDue = [
    { field: "applicationId", headerName: 'Application No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
    { field: "creationDate", type: 'date', headerName: 'Submission Date', align: 'center', sortable: false, filterable: true, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
    { field: "applicantName", type: 'text', headerName: 'Applicant Name', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
    { field: "referenceno", type: 'text', headerName: 'Reference No.', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle },
    {
      field: "applicationStatusId",
      headerStyle: tableStyleOverDue.headerStyle,
      headerCellStyle: tableStyleOverDue.headerCellStyle,
      rowCellStyle: tableStyleOverDue.rowCellStyle,
      headerName: "Status",
      align: 'center',
      sortable: false,
      filterable: true,
      type: 'singleSelect',
      valueOptions: ['Pending', 'In Process', 'Approved', 'Completed', 'Objection'],
      renderCell: (params) => {
        let btnText = (params.applicationStatusId)
        return (
          <div className={getClassName(btnText)} >{btnText}</div>
        )
      }
    },
    { field: "description", type: 'dateTime', headerName: 'Description', align: 'center', sortable: false, filterable: false, headerStyle: tableStyleOverDue.headerStyle, headerCellStyle: tableStyleOverDue.headerCellStyle, rowCellStyle: tableStyleOverDue.rowCellStyle }
  ]

  useImperativeHandle(ref, () => ({
    handleRowClick
  }));
  const location = useLocation()
  const currentPath = location.pathname;

  return (
    <>
      {/* Applications Table */}
      {
        (props.showTable && currentPath == "/change-of-tariff-table") &&
        <Box className='form-box'>
          <div style={{ display: 'flex', flexDirection: "row" }}>
            <Box className='application-table' style={{ marginRight: '10px' }}>
              <h3 style={{ color: '#006ad1', marginBottom: '10px' }}>Change of Tariff  ( {numberFormatting(totalRecordsNormal) ? numberFormatting(totalRecordsNormal) : "-"} )</h3>
              <div className='div-datagrid' >
                <BasicTable
                  columns={tblColumns}
                  data={changeOfTariffApplicationsToDataGrid}
                  handleRowClick={(params) => handleRowClick(params.applicationId)}
                  sx={tableStyle}
                  rowHeight={37.5}
                  pageSize={20}
                  firstPage={handleFirstPageNormal}
                  lastPage={handleLastPageNormal}
                  totalPages={totalPagesNormal}
                  totalRecords={totalRecordsNormal}
                  currentPage={currentPageNormal}
                  handleFilterDateFrom={handleDateFromFilterNormal}
                  handleFilterDateTo={handleDateToFilterNormal}
                  resetDateFilter={handleResetDateFilterNormal}
                  handleFilterProgressId={handleProgressIdFilterNormal}
                  handleFilterObjectionStatus={handleObjectionStatusFilterNormal}
                  resetProgressIdFilter={handleResetProgressIdFilterNormal}
                  resetObjectionStatusFilter={handleResetObjectionStatusFilterNormal}
                  nextPage={handleNextPageNormal}
                  previousPage={handlePreviousPageNormal}
                  isLoading={isLoad}
                  rowsPerPageOptions={[18, 30, 60]}
                  rowsPageOption={false}
                  getRowStyle={(params) => {
                    return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyle.evenRow : tableStyle.oddRow
                  }}
                />
              </div>
            </Box>
            <Box className='application-table' >
              <div style={{ display: 'flex', alignItems: 'end' }}>
                <h3 style={{ color: '#9d192f', marginBottom: '10px' }}><img src={warning} alt='icon' style={{ width: '1vw', marginRight: '5px' }} />Over Due Applications  ( {numberFormatting(totalRecordsOverdue) ? numberFormatting(totalRecordsOverdue) : "-"} )</h3>
              </div>
              <div className='div-datagrid' >
                <BasicTable
                  columns={tblColumnsOverDue}
                  data={changeOfTariffApplicationsOverDueToDataGrid}
                  handleRowClick={(params) => handleRowClick(params.applicationId)}
                  sx={tableStyleOverDue}
                  rowHeight={37.5}
                  pageSize={20}
                  firstPage={handleFirstPageOverdue}
                  lastPage={handleLastPageOverdue}
                  nextPage={handleNextPageOverdue}
                  previousPage={handlePreviousPageOverdue}
                  handleFilterDateFrom={handleDateFromFilterOverdue}
                  handleFilterDateTo={handleDateToFilterOverdue}
                  resetDateFilter={handleResetDateFilterOverdue}
                  resetProgressIdFilter={handleResetProgressIdFilterOverdue}
                  resetObjectionStatusFilter={handleResetObjectionStatusFilterOverdue}
                  handleFilterProgressId={handleProgressIdFilterOverdue}
                  handleFilterObjectionStatus={handleObjectionStatusFilterOverdue}
                  totalPages={totalPagesOverdue}
                  totalRecords={totalRecordsOverdue}
                  isLoading={isLoadd}
                  currentPage={currentPageOverdue}
                  rowsPerPageOptions={[18, 30, 60]}
                  rowsPageOption={false}
                  getRowStyle={(params) => {
                    return params.indexRelativeToCurrentPage % 2 === 0 ? tableStyleOverDue.evenRow : tableStyleOverDue.oddRow
                  }}
                />
              </div>
            </Box>
          </div>
        </Box>
      }

      {/* Main Popup */}
      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth={true}
        maxWidth={'false'}
        className='main-dialog'
      >
        <DialogTitle className="dialog-title" >
          <Grid container spacing={1} className='headercontainer'>
            <Grid item lg={0.5}></Grid>
            <Grid item lg={11} className='applicationTitleGrid'>
              <Typography className="applicationTitleText">Change of Tariff -
                <span style={{ color: 'white' }}>
                  {dialogRowData.applicationProgressId === 0 && ' Document Submission'}
                  {dialogRowData.applicationProgressId === 1 && ' Document Verification'}
                  {dialogRowData.applicationProgressId === 2 && ' Arrear Verification'}
                  {dialogRowData.applicationProgressId === 3 && ' Site Survey'}
                  {dialogRowData.applicationProgressId === 4 && ' DN Payment Submission'}
                  {dialogRowData.applicationProgressId === 5 && ' DN Payment Verification'}
                  {dialogRowData.applicationProgressId === 6 && ' Service Job Order'}
                  {dialogRowData.applicationProgressId === 7 && ' SCO Execution'}
                  {dialogRowData.applicationProgressId === 8 && ' Ready for Billing'}
                  {dialogRowData.applicationProgressId === 9 && ' Completed'}
                </span>
              </Typography>
            </Grid>
            <Grid item lg={0.25}>
            </Grid>
            <Grid item lg={0.25} className="closeIcon" >
              <CloseIcon id="clearPopup" onClick={handleClose} sx={{ color: 'white' }} />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <DialogContentText className="dialog-content">
            <Grid container spacing={1} className='headercontainer'>
              <Grid item lg={12} className='status-bar'>
                <StepProgressBar array={COTStatusBarArray} applicationProgressId={dialogRowData.applicationProgressId} openDetailsPopUp={openDetailsPopUp} pageName='Change of Tariff' />
              </Grid>
              <Grid item lg={12} className='application-details'>
                <Grid container gap={'4%'} className="first-row">
                  <Grid item lg={1.5} className='first-row-item'>
                    <p className='prop-title'> Application Id.</p>
                    <p className='prop-detail'> {dialogRowData.applicationId}</p>
                  </Grid>
                  <Grid item lg={1.5} className='first-row-item'>
                    <p className='prop-title'> Reference No.</p>
                    <p className='prop-detail'> {dialogRowData.referenceNumber ? dialogRowData.referenceNumber : "-"}</p>
                  </Grid>
                  <Grid item lg={3.5} className='first-row-item'>
                    <p className='prop-title'> Address</p>
                    <p className='prop-detail'> {dialogRowData.address ? dialogRowData.address : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'> Connection Type </p>
                    <p className='prop-detail'> {dialogRowData.connectionType ? dialogRowData.connectionType : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'> Tariff </p>
                    <p className='prop-detail'> {dialogRowData.tariff ? dialogRowData.tariff : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'> Subdivision </p>
                    <p className='prop-detail'> {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
                  </Grid>
                  <Grid item lg={1.5} className='first-row-item'>
                    <p className='prop-title'> Applicant Name</p>
                    <p className='prop-detail'> {dialogRowData.applicantName ? dialogRowData.applicantName : '-'}</p>
                  </Grid>
                  <Grid item lg={1.5} className='first-row-item'>
                    <p className='prop-title'> Applicant CNIC</p>
                    <p className='prop-detail'> {dialogRowData.applicantCNIC ? dialogRowData.applicantCNIC : '-'}</p>
                  </Grid>
                  <Grid item lg={1.5} className='first-row-item'>
                    <p className='prop-title'> Applicant Phone</p>
                    <p className='prop-detail'> {dialogRowData.applicantPhoneNo ? dialogRowData.applicantPhoneNo : '-'}</p>
                  </Grid>
                  <Grid item lg={1.5} className='first-row-item'>
                    <p className='prop-title'> Applicant Email</p>
                    <p className='prop-detail'> {dialogRowData.applicantEmail ? dialogRowData.applicantEmail : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'> Current Tariff </p>
                    <p className='prop-detail'> {dialogRowData.currentTariff ? dialogRowData.currentTariff : '-'}</p>
                  </Grid>
                  <Grid item lg={1} className='first-row-item'>
                    <p className='prop-title'> New Tariff</p>
                    <p className='prop-detail'> {dialogRowData.newTariff ? dialogRowData.newTariff.split('-')[0] : "-"}</p>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item className='processing-summary'>
                <p className='title'>Activity Log</p>
                {/*   */}
                <div className='processing-summary-table'>
                  <ProcessingSummaryTable data={tableDataProcessingSummary} columns={tableColumnsProcessingSummary} openDetailsPopUp={openDetailsPopUp} />
                </div>
              </Grid>
              <Grid item className="action-form">
                <div className='fields'>
                  {
                    dialogRowData.applicationProgressId === 0 ?
                      <>
                        <h3 className='step-title'>Documents Pending</h3>
                        {
                          // CheckPermissions(permissions,'General Services', 'Change of Tariff', 'Basic Permissions', 'Update') ?
                          CheckPermissions(permissions, 'General Services', 'Change of Tariff') ?
                            <p className='group-description'>To process application, some documents are yet to be provided by the customer. If available, you can upload the remaining documents by clicking below button.</p> :
                            <p className='group-description'>To process application, some documents are yet to be provided by the customer.</p>
                        }
                      </> :
                      dialogRowData.applicationProgressId === 1 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                        CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Document Verification') ?
                          <>
                            <h3 className='step-title'>Documents Verification</h3>
                            <Grid className='document-verification-container' container spacing={1} sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '1%', padding: '2%' }} >
                              {
                                (dialogRowData.applicantCNICFront || dialogRowData.applicantCNICBack) &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: (dialogRowData.applicantCNICFrontFlag && dialogRowData.applicantCNICBackFlag) ? getDocumentBackGroundColor(dialogRowData.applicantCNICFrontFlag) : getDocumentBackGroundColor(flag_applicantCNICFront), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                      <div onClick={() => { if (!copyOfApplicantCNICVerifyPopUp) { setCopyOfApplicantCNICVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }} >
                                        {
                                          dialogRowData.applicantCNICFront.slice(0, 6) === 'data:i' ? (
                                            flag_applicantCNICFront === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_applicantCNICFront === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <>
                                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                                              </>
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          copyOfApplicantCNICVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                                            hideDocVerifyPopup={hideCopyOfApplicantCNICVerifyAlert}
                                            documentName="Applicant CNIC"
                                            documentImage={dialogRowData.applicantCNICFront}
                                            backDocumentImage={dialogRowData.applicantCNICBack}
                                            width={'100%'}
                                            document={dialogRowData.applicantCNICFront}
                                            documentFlag={dialogRowData.applicantCNICFrontFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="copyOfApplicantCNIC"
                                            flag_document={flag_applicantCNICFront}
                                            flag_documentBack={flag_applicantCNICBack}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>Applicant's CNIC.</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              }
                              {
                                dialogRowData.owenershipImage &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: dialogRowData.owenershipImageFlag ? getDocumentBackGroundColor(dialogRowData.owenershipImageFlag) : getDocumentBackGroundColor(flag_owenershipImage), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                      <div onClick={() => { if (!owenershipImageVerifyPopUp) { setOwenershipImageVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                        {
                                          dialogRowData.owenershipImage.slice(0, 6) === 'data:i' ? (
                                            flag_owenershipImage === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_owenershipImage === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          owenershipImageVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={owenershipImageVerifyPopUp}
                                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                                            documentName="Property Document"
                                            documentImage={dialogRowData.owenershipImage}
                                            width={'100%'}
                                            document={dialogRowData.owenershipImage}
                                            documentFlag={dialogRowData.owenershipImageFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="owenershipImage"
                                            flag_document={flag_owenershipImage}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>Property Documents</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              }
                              {
                                (dialogRowData.authorityLetterImage) &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: (dialogRowData.authorityLetterFlag) ? getDocumentBackGroundColor(dialogRowData.authorityLetterFlag) : getDocumentBackGroundColor(flag_authorityLetter), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                      <div onClick={() => { if (!authhorityLetterVerifyPopUp) { setAuthhorityLetterVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }} >
                                        {
                                          dialogRowData.authorityLetterImage.slice(0, 6) === 'data:i' ? (
                                            flag_authorityLetter === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.authorityLetterImage} width='80' height='110' />

                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_authorityLetter === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.authorityLetterImage} width='80' height='110' />

                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <>
                                                <Base64Image data={dialogRowData.authorityLetterImage} width='80' height='110' />

                                              </>
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          authhorityLetterVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={authhorityLetterVerifyPopUp}
                                            hideDocVerifyPopup={hideAuthorityLetterVerifyAlert}
                                            documentName="Authority Letter"
                                            documentImage={dialogRowData.authorityLetterImage}
                                            // // backDocumentImage={dialogRowData.otherDocumentsBack}
                                            width={'100%'}
                                            document={dialogRowData.authorityLetterImage}
                                            documentFlag={dialogRowData.authorityLetterFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="authorityLetter"
                                            flag_document={flag_authorityLetter}
                                          // // flag_documentBack={flag_otherDocumentsBack}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>Authority Letter</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              }
                              {
                                (dialogRowData.otherDocuments) &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: (dialogRowData.otherDocumentsFlag) ? getDocumentBackGroundColor(dialogRowData.otherDocumentsFlag) : getDocumentBackGroundColor(flag_otherDocuments), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                      <div onClick={() => { if (!otherDocumentsVerifyPopUp) { setOtherDocumentsVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }} >
                                        {
                                          dialogRowData.otherDocuments.slice(0, 6) === 'data:i' ? (
                                            flag_otherDocuments === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='110' />

                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_otherDocuments === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='110' />

                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <>
                                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='110' />

                                              </>
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          otherDocumentsVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={otherDocumentsVerifyPopUp}
                                            hideDocVerifyPopup={hideOtherDocumentsVerifyAlert}
                                            documentName="Previous Owner CNIC"
                                            documentImage={dialogRowData.otherDocuments}
                                            // // backDocumentImage={dialogRowData.otherDocumentsBack}
                                            width={'100%'}
                                            document={dialogRowData.otherDocuments}
                                            documentFlag={dialogRowData.otherDocumentsFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="otherDocuments"
                                            flag_document={flag_otherDocuments}
                                          // // flag_documentBack={flag_otherDocumentsBack}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>Other Documents</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              }
                            </Grid>
                          </> :
                          <>
                            <h3 className='step-title'>Documents Verification</h3>
                            <p className='group-description'>Documents verification is in process by the CSL.</p>
                          </> :
                        dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 1 ?
                          <>
                            <h3 className='step-title'>Documents Objection</h3>
                            <Grid className='document-verification-container' container spacing={1} sx={{ display: 'flex', justifyContent: 'flex-start', marginTop: '1%', padding: '2%' }} >
                              {
                                (dialogRowData.applicantCNICFront || dialogRowData.applicantCNICBack) &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: (dialogRowData.applicantCNICFrontFlag && dialogRowData.applicantCNICBackFlag) ? getDocumentBackGroundColor(dialogRowData.applicantCNICFrontFlag) : getDocumentBackGroundColor(flag_applicantCNICFront), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                      <div onClick={() => { if (!copyOfApplicantCNICVerifyPopUp) { setCopyOfApplicantCNICVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }} >
                                        {
                                          dialogRowData.applicantCNICFront.slice(0, 6) === 'data:i' ? (
                                            flag_applicantCNICFront === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_applicantCNICFront === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <>
                                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                                              </>
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          copyOfApplicantCNICVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                                            hideDocVerifyPopup={hideCopyOfApplicantCNICVerifyAlert}
                                            documentName="Applicant CNIC"
                                            documentImage={dialogRowData.applicantCNICFront}
                                            backDocumentImage={dialogRowData.applicantCNICBack}
                                            width={'100%'}
                                            document={dialogRowData.applicantCNICFront}
                                            documentFlag={dialogRowData.applicantCNICFrontFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="copyOfApplicantCNIC"
                                            flag_document={flag_applicantCNICFront}
                                            flag_documentBack={flag_applicantCNICBack}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>Applicant's CNIC.</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              }
                              {
                                dialogRowData.owenershipImage &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: dialogRowData.owenershipImageFlag ? getDocumentBackGroundColor(dialogRowData.owenershipImageFlag) : getDocumentBackGroundColor(flag_owenershipImage), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                                      <div onClick={() => { if (!owenershipImageVerifyPopUp) { setOwenershipImageVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                        {
                                          dialogRowData.owenershipImage.slice(0, 6) === 'data:i' ? (
                                            flag_owenershipImage === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_owenershipImage === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          owenershipImageVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={owenershipImageVerifyPopUp}
                                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                                            documentName="Property Document"
                                            documentImage={dialogRowData.owenershipImage}
                                            width={'100%'}
                                            document={dialogRowData.owenershipImage}
                                            documentFlag={dialogRowData.owenershipImageFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="owenershipImage"
                                            flag_document={flag_owenershipImage}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>Property Documents</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              }
                              {
                                (dialogRowData.authorityLetterImage) &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: (dialogRowData.authorityLetterFlag) ? getDocumentBackGroundColor(dialogRowData.authorityLetterFlag) : getDocumentBackGroundColor(flag_authorityLetter), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                      <div onClick={() => { if (!authhorityLetterVerifyPopUp) { setAuthhorityLetterVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }} >
                                        {
                                          dialogRowData.authorityLetterImage.slice(0, 6) === 'data:i' ? (
                                            flag_authorityLetter === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.authorityLetterImage} width='80' height='50' />
                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_authorityLetter === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.authorityLetterImage} width='80' height='50' />
                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <>
                                                <Base64Image data={dialogRowData.authorityLetterImage} width='80' height='50' />
                                              </>
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          authhorityLetterVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={authhorityLetterVerifyPopUp}
                                            hideDocVerifyPopup={hideAuthorityLetterVerifyAlert}
                                            documentName="Authority Letter"
                                            documentImage={dialogRowData.authorityLetterImage}
                                            width={'100%'}
                                            document={dialogRowData.authorityLetterImage}
                                            documentFlag={dialogRowData.authorityLetterFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="authorityLetter"
                                            flag_document={flag_authorityLetter}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>Authority Letter</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              }
                              {
                                (dialogRowData.otherDocuments) &&
                                <Grid item lg={2}>
                                  <Grid container sx={{ backgroundColor: (dialogRowData.otherDocumentsFlag) ? getDocumentBackGroundColor(dialogRowData.otherDocumentsFlag) : getDocumentBackGroundColor(flag_otherDocuments), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                      <div onClick={() => { if (!otherDocumentsVerifyPopUp) { setOtherDocumentsVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }} >
                                        {
                                          dialogRowData.otherDocuments.slice(0, 6) === 'data:i' ? (
                                            flag_otherDocuments === 1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='50' />

                                                <img
                                                  src={tickicon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Tick Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : flag_otherDocuments === -1 ? (
                                              <>
                                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='50' />

                                                <img
                                                  src={crossIcon}
                                                  width='25px'
                                                  height='25px'
                                                  alt="Cross Icon"
                                                  className="doc-verification-status-icon"
                                                />
                                              </>
                                            ) : (
                                              <>
                                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='50' />
                                              </>
                                            )
                                          ) : (
                                            <Base64Image data={pdfIcon} width='40' />
                                          )
                                        }
                                        {
                                          otherDocumentsVerifyPopUp &&
                                          <OpenBase64ImageInPopup
                                            docVerifyPopUp={otherDocumentsVerifyPopUp}
                                            hideDocVerifyPopup={hideOtherDocumentsVerifyAlert}
                                            documentName="Previous Owner CNIC"
                                            documentImage={dialogRowData.otherDocuments}
                                            width={'100%'}
                                            document={dialogRowData.otherDocuments}
                                            documentFlag={dialogRowData.otherDocumentsFlag}
                                            applicationProgressId={dialogRowData.applicationProgressId}
                                            objectionStatus={dialogRowData.objectionStatus}
                                            updateDocFlag={updateDocFlag}
                                            titleToUpdateFlag="otherDocuments"
                                            flag_document={flag_otherDocuments}
                                          />
                                        }
                                      </div>
                                    </Grid>
                                    <Grid item lg={12} className="tittlegrid" >
                                      <p className='docTitle'>Other Document</p>
                                    </Grid>
                                  </Grid>
                                </Grid>
                              }
                            </Grid>
                          </> :
                          dialogRowData.applicationProgressId === 2 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                            <>
                              <h3 className='step-title'>Arrear Verification</h3>
                              {
                                CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Arears Verification') ?
                                  <>
                                    <Grid container className='field-survey-container'>
                                      <Grid item lg={12}>
                                        <Grid container spacing={2}>
                                          {
                                            arrearsDetails.arrearsAmount ?
                                              <Grid item container className='fieldLabel1'>
                                                <Grid item lg={3}>
                                                  <Typography sx={{ fontWeight: 'bold', fontSize: 13 }} className='fieldLabel'>Arrear Amount</Typography>
                                                  <Typography className='fieldLabels'>{arrearsDetails.arrearsAmount ? arrearsDetails.arrearsAmount : '-'}</Typography>
                                                </Grid>
                                                <Grid item lg={3}>
                                                  <Typography sx={{ fontWeight: 'bold', fontSize: 13 }} className='fieldLabel'>Consumer Name</Typography>
                                                  <Typography className='fieldLabels'>{arrearsDetails.consumerName ? arrearsDetails.consumerName : '-'}</Typography>
                                                </Grid>
                                                <Grid item lg={3}>
                                                  <Typography sx={{ fontWeight: 'bold', fontSize: 13 }} className='fieldLabel'>Consumer Phone No.</Typography>
                                                  <Typography className='fieldLabels'>{arrearsDetails.consumerNo ? arrearsDetails.consumerNo : '-'}</Typography>
                                                </Grid>
                                                <Grid item lg={3}>
                                                  <Typography sx={{ fontWeight: 'bold', fontSize: 13 }} className='fieldLabel' >Consumer Address</Typography>
                                                  <Typography className='fieldLabels'>{arrearsDetails.consumerAddress ? arrearsDetails.consumerAddress : '-'}</Typography>
                                                </Grid>
                                              </Grid>
                                              :
                                              <Box sx={{ color: '#00B091', marginTop: '2%', marginLeft: '2%', backgroundColor: '#DFFFE4', padding: '3%', width: '100%', display: 'flex', flexDirection: 'row' }}>
                                                <ErrorIcon style={{ color: '#00B091', marginLeft: '1%' }} />
                                                <h4 style={{ marginLeft: '10px', fontSize: '1vw', fontWeight: 'normal' }}>{noArrears}</h4>
                                              </Box>
                                          }
                                          {
                                            <Grid item lg={12}>
                                              <Grid item lg={12} sx={{ display: 'flex', alignItems: 'center', marginLeft: '5%', marginTop: '5%' }}>
                                                <img src={dialogRowData.applicantCNICFront} alt="Cnic Front" style={{ width: '45%', height: '40%' }} ></img>
                                                <img src={dialogRowData.applicantCNICBack} alt="Cnic Back" style={{ width: '45%', height: '40%', marginLeft: '2%' }} ></img>
                                              </Grid>
                                            </Grid>
                                          }
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                  </> :
                                  <p className='group-description'>Arears Verification is in process by the LS DR of subdivision: {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}. </p>
                              }
                            </> :
                            dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 1 ?
                              <>
                                <h3 className='step-title'>Arrears Objection</h3>
                                <>
                                  <Grid item lg={12}>
                                    <Grid item lg={12} sx={{ marginTop: '2%', alignItems: 'center', marginLeft: '8%' }}>
                                      <img src={dialogRowData.applicantCNICFront} alt="Cnic Front" style={{ width: '40%', height: '40%' }} ></img>
                                      <img src={dialogRowData.applicantCNICBack} alt="Cnic Back" style={{ width: '40%', height: '40%', marginLeft: '2%' }} ></img>
                                    </Grid>
                                  </Grid>
                                  <Grid item lg={12} className='arrear-container'>
                                    <Grid className='arrear-container1' item container spacing={2}>
                                      <Grid item lg={3}>
                                        <Typography className='fieldLabel'>Reference No.</Typography>
                                        <Typography className='arrear-label'>{arrearsDetailsToDisplay.refNo ? arrearsDetailsToDisplay.refNo : '-'}</Typography>
                                      </Grid>
                                      <Grid item lg={3}>
                                        <Typography className='fieldLabel'>Arrear Amount</Typography>
                                        <Typography className='arrear-label'>{arrearsDetailsToDisplay.arrearsAmount ? arrearsDetailsToDisplay.arrearsAmount : '-'}</Typography>
                                      </Grid>
                                      <Grid item lg={3}>
                                        <Typography className='fieldLabel'>Consumer Name</Typography>
                                        <Typography className='arrear-label'>{arrearsDetailsToDisplay.consumerName ? arrearsDetailsToDisplay.consumerName : '-'}</Typography>
                                      </Grid>
                                      <Grid item lg={3}>
                                        <Typography className='fieldLabel'>Consumer Phone No.</Typography>
                                        <Typography className='arrear-label'>{arrearsDetailsToDisplay.consumerNo ? arrearsDetailsToDisplay.consumerNo : '-'}</Typography>
                                      </Grid>
                                      <Grid item lg={12}>
                                        <Typography className='fieldLabel'  >Consumer Address</Typography>
                                        <Typography className='arrear-label'>{arrearsDetailsToDisplay.consumerAddress ? arrearsDetailsToDisplay.consumerAddress : '-'}</Typography>
                                      </Grid>
                                    </Grid>
                                    <>
                                      {
                                        arrearsDetailsToDisplay.paidArearImage &&
                                        <Grid item lg={4}>
                                          <Typography sx={{ fontWeight: 'bold' }} >Arear Paid Bill Image </Typography>
                                          <a href="#" onClick={() => openBase64Image(arrearsDetailsToDisplay.paidArearImage)} target='_blank' rel="noreferrer" style={{ display: 'flex', justifyContent: 'space-between' }} >
                                            <Base64Image data={arrearsDetailsToDisplay.paidArearImage} width={80} />
                                          </a>
                                        </Grid>
                                      }
                                      {
                                        arrearsDetailsToDisplay.paidArearDate &&
                                        <Grid item lg={4} >
                                          <Typography sx={{ fontWeight: 'bold' }}  >Arear Paid Date </Typography>
                                          <Typography >{arrearsDetailsToDisplay.paidArearDate}</Typography>
                                        </Grid>
                                      }
                                    </>
                                  </Grid>
                                </>
                              </> :
                              dialogRowData.applicationProgressId === 3 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                <>
                                  <h3 className='step-title'>Field Survey</h3>
                                  {
                                    CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Site Survey') ?
                                      <>
                                        <Grid container spacing={0.5} className='field-survey-container'>
                                          <Grid item lg={4} >
                                            <Typography className='fieldLabel' >Owner Consent Validated</Typography>
                                            <FormControl >
                                              <RadioGroup
                                                defaultValue={consentVerificationFlag}
                                                value={consentVerificationFlag}
                                                className='radio'
                                                name="iv_consent_flag"
                                                onChange={() => { if (consentVerificationFlag === 1) { setConsentVerificationFlag(0) } else { setConsentVerificationFlag(1) } }}
                                                row
                                              >
                                                <FormControlLabel value={1} className='option-left' sx={{ padding: '0px 30px', marginRight: '15px' }} control={<Radio />} label="Yes" />
                                                <FormControlLabel value={0} className='option-left' sx={{ padding: '0px 30px' }} control={<Radio />} label="No" />
                                              </RadioGroup>
                                            </FormControl>
                                          </Grid>
                                          {
                                            consentVerificationFlag == 1 &&
                                            <Grid item lg={4}>
                                              <Typography className='fieldLabel' >Signed Consent Image</Typography>
                                              <Box className="form-error">
                                                {signedConsentImageFormik.errors.iv_signed_consent_image && signedConsentImageFormik.touched.iv_signed_consent_image ? (signedConsentImageFormik.errors.iv_signed_consent_image) : null}
                                              </Box>
                                              {
                                                signedConsentFormImage ?
                                                  <>
                                                    <Button varient='outlined' component="label" startIcon={<CloseIcon sx={{ color: 'red' }} onClick={() => { setSignedConsentFormImageImage('') }} />}  >
                                                      {signedConsentFormImageThumbnail && <img src={signedConsentFormImageThumbnail} alt="Signed Consent Form" width="80" />}
                                                    </Button>
                                                  </>
                                                  :
                                                  <>
                                                    <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />} sx={{ padding: '4%', width: '100%', backgroundColor: 'white' }}  >
                                                      Upload
                                                      <input hidden accept="image/*" id='iv_signed_consent_image' name='iv_signed_consent_image' type="file" onChange={SignedConsentFormImage} />
                                                    </Button>
                                                  </>
                                              }
                                            </Grid>
                                          }
                                        </Grid>
                                      </> :
                                      <p className='group-description'>
                                        Field survey is in process by the Lineman: {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}
                                      </p>
                                  }
                                </> :
                                dialogRowData.applicationProgressId === 3 && dialogRowData.objectionStatus === 1 ?
                                  <>
                                    <h3 className='step-title'>Site Survey Objection</h3>
                                    {
                                      // CheckPermissions(permissions,'General Services', 'Change of Tariff', 'Workflow Permissions', 'Field Verification') ?
                                      CheckPermissions(permissions, 'General Services', 'Change of Tariff') ?
                                        <>
                                          <Grid container className='sco-container' sx={{ marginTop: '10px' }}>
                                            <Grid item lg={4} className='item'>
                                              <Typography className='title'>
                                                Reason
                                              </Typography>
                                              <Typography className='value'>{dialogRowData.remarks}</Typography>
                                            </Grid>
                                          </Grid>
                                        </>
                                        :
                                        <p className='group-description'>The application has been objected at field survey stage. </p>
                                    }
                                  </> :
                                  dialogRowData.applicationProgressId === 4 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                    <>
                                      <h3 className='step-title'>Application Details</h3>
                                      <Grid container className='sco-container'>
                                        <Grid item lg={4} className='item'>
                                          <Typography className='title'>Consent Image</Typography>
                                        </Grid>
                                        <Grid item lg={8}></Grid>
                                        <Grid item lg={1} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                          <div onClick={() => { if (!consentImagePopUp) { setConsentImagePopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                            <Base64Image data={consentImageDetails.consentImageChnageofTariff} width={80} />
                                          </div>
                                          {
                                            consentImagePopUp &&
                                            <OpenBase64ImageInPopup
                                              docVerifyPopUp={consentImagePopUp}
                                              hideDocVerifyPopup={hideConsentImagePopUp}
                                              documentName="Signed Consent Image"
                                              documentImage={consentImageDetails.consentImageChnageofTariff}
                                              width={'100%'}
                                              document={consentImageDetails.consentImageChnageofTariff}
                                              documentFlag={1}
                                              applicationProgressId={dialogRowData.applicationProgressId}
                                              objectionStatus={dialogRowData.objectionStatus}
                                              updateDocFlag={updateDocFlag}
                                              titleToUpdateFlag="copyOfApplicantCNIC"
                                              flag_document={1}
                                            />
                                          }
                                        </Grid>
                                        {
                                          CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Validate Signed Consent') ?
                                            <></> :
                                            <p className='group-description'>
                                              Signed Consent is in approval by the SDO: {subdivisionName(dialogRowData.subDivisionCode, subDivisions)}
                                            </p>
                                        }
                                      </Grid>
                                    </> :
                                    dialogRowData.applicationProgressId === 4 && dialogRowData.objectionStatus === 1 ?
                                      <>
                                        <h3 className='step-title'>Demand Notice Objection</h3>
                                        <p className='group-description'>Unable to generate the demand notice. Please contact the relevant field operations officer. </p>
                                      </> :
                                      dialogRowData.applicationProgressId === 5 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                        <>
                                          <div className='step-title' style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '1%', padding: '0.5%' }}>
                                            <h4 className='step-title' >DN Payment Submission</h4>
                                            <Button variant="outlined" onClick={() => downloadDNPDF(dialogRowData.applicationId)} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><PrintIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> DN </Button>
                                          </div>
                                          <Grid container className='dn-payment-submission-container'>
                                            <Grid item lg={3} className='item'>
                                              <Typography className='title'>Demand Notice No.</Typography>
                                              <Typography className='value'>{dnDetails.demandNoticeNo ? dnDetails.demandNoticeNo : '-'}</Typography>
                                            </Grid>
                                            <Grid item lg={3} className='item'>
                                              <Typography className='title'>Reference No.</Typography>
                                              <Typography className='value'>{dnDetails.connectionAccountNo ? dnDetails.connectionAccountNo : '-'}</Typography>
                                            </Grid>
                                            <Grid item lg={3} className='item'>
                                              <Typography className='title'>Issue Date</Typography>
                                              <Typography className='value'>{dnDetails.issueDate ? convertDate(dnDetails.issueDate) : '-'}</Typography>
                                            </Grid>
                                            <Grid item lg={3} className='item'>
                                              <Typography className='title'>Due Date</Typography>
                                              <Typography className='value'>{dnDetails.dueDate ? convertDate(dnDetails.dueDate) : '-'}</Typography>
                                            </Grid>
                                            <Grid item lg={3} className='item'>
                                              <Typography className='title'>Capital Cost</Typography>
                                              <Typography className='value'>{dnDetails.capitalCostAmount ? numberFormatting(dnDetails.capitalCostAmount) : '-'}</Typography>
                                            </Grid>
                                            <Grid item lg={3} className='item'>
                                              <Typography className='title'>Security Cost</Typography>
                                              <Typography className='value'>{dnDetails.dNamount ? numberFormatting(dnDetails.dNamount) : '-'}</Typography>
                                            </Grid>
                                            <Grid item lg={3} className='item'>
                                              <Typography className='title'>Total Cost</Typography>
                                              <Typography className='value'>{(dnDetails.dNamount) ? numberFormatting(parseInt(dnDetails.dNamount)) : '-'}</Typography>
                                            </Grid>
                                            <Grid item lg={3} className='item'>
                                              <Typography className='title'>Bank Name</Typography>
                                              <Typography className='value'>{dnDetails.bankName ? dnDetails.bankName : '-'}</Typography>
                                            </Grid>
                                          </Grid>
                                          {
                                            CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'DN Image Uploading') ?
                                              <Grid container spacing={5} display='flex' flexDirection='row' className='field-survey-container'>
                                                <Grid item style={{ marginTop: '1%', width: '25%' }}>
                                                  <Typography className='fieldLabel' sx={{ paddingTop: '10px', paddingBottom: '2%' }} >Receipt Image</Typography>
                                                  {
                                                    dnReceiptImage ?
                                                      <>
                                                        <Button varient='outlined' component="label" startIcon={<CloseIcon sx={{ color: 'red' }} onClick={() => { setDnReceiptImage('') }} />}  >
                                                          {dnReceiptImageThumbnail && <img src={dnReceiptImageThumbnail} alt="DN Receipt" width="80" />}
                                                        </Button>
                                                      </>
                                                      :
                                                      <>
                                                        <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />} sx={{ padding: '4%', width: '100%', backgroundColor: 'white' }}  >
                                                          Upload
                                                          <input hidden accept={documentExtensions} id='iv_receipt_image' name='iv_receipt_image' type="file" onChange={DnReceiptImage} />
                                                        </Button>
                                                      </>
                                                  }
                                                  <Box className='form-error'>{dnPymentReceiptFormik.errors.iv_receipt_image && dnPymentReceiptFormik.touched.iv_receipt_image ? (dnPymentReceiptFormik.errors.iv_receipt_image) : null}</Box>
                                                </Grid>
                                                <Grid item style={{ marginTop: '1%' }}>
                                                  <Typography className='fieldLabel' sx={{ paddingTop: '10px', paddingBottom: '2%' }} >Payment Date</Typography>
                                                  <input
                                                    name="iv_payment_date"
                                                    value={dnPymentReceiptFormik.values.iv_payment_date}
                                                    fullWidth
                                                    onChange={dnPymentReceiptFormik.handleChange}
                                                    onBlur={dnPymentReceiptFormik.handleBlur}
                                                    type='date'
                                                    className='fieldReferenceNo'
                                                    style={{ width: '200px', height: '30px', padding: '4px' }}
                                                    min={dnDetails ? dnDetails.issueDate ? dnDetails.issueDate.slice(0, 10) : null : null}
                                                    max={new Date().toISOString().split('T')[0]}
                                                  />
                                                  <Box className='form-error'>{dnPymentReceiptFormik.errors.iv_payment_date && dnPymentReceiptFormik.touched.iv_payment_date ? (dnPymentReceiptFormik.errors.iv_payment_date) : null}</Box>
                                                </Grid>
                                              </Grid> :
                                              <p className='group-description'>
                                                Demand note payment is in process by the consumer.
                                              </p>
                                          }
                                        </> :
                                        dialogRowData.applicationProgressId === 5 && dialogRowData.objectionStatus === 1 ?
                                          <>
                                            <h3 className='step-title'>Demand Notice Payment Objection</h3>
                                            {
                                              // CheckPermissions(permissions,'General Services', 'Change of Tariff', 'Workflow Permissions', 'Demand Note Verification') ?
                                              CheckPermissions(permissions, 'General Services', 'Change of Tariff') ?
                                                <p className='group-description'>Demand notice payment was declared as unpaid. In case the payment has been done, remove objection by clicking below button.</p> :
                                                <p className='group-description'>Demand notice payment was declared as unpaid by the concerned revenue officer. </p>
                                            }
                                          </> :
                                          dialogRowData.applicationProgressId === 6 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                            <>
                                              <h3 className='step-title'>Verify Demand Notice Payment</h3>
                                              <Grid container className='paidDnContainer'>
                                                <Grid item lg={3} className='item'>
                                                  <Typography className='title'>Demand Notice No.</Typography>
                                                  <Typography className='value'>{dnDetails.demandNoticeNo}</Typography>
                                                </Grid>
                                                <Grid item lg={3} className='item'>
                                                  <Typography className='title'>Reference No.</Typography>
                                                  <Typography className='value'>{dnDetails.connectionAccountNo ? dnDetails.connectionAccountNo : '-'}</Typography>
                                                </Grid>
                                                <Grid item lg={3} className='item'>
                                                  <Typography className='title'>DN. Amount</Typography>
                                                  <Typography className='value'>{(dnDetails.dNamount) ? numberFormatting(parseInt(dnDetails.dNamount)) : '-'}</Typography>
                                                </Grid>
                                                <Grid item lg={3} className='item'>
                                                  <Typography className='title'>Payment Date</Typography>
                                                  <Typography className='value'>{dnPaymentDate}</Typography>
                                                </Grid>
                                                <Grid item lg={12}></Grid>
                                                <Grid item lg={3} className='paidDnDocument item'>
                                                  <Typography className='title'>Paid Demand Notice</Typography>
                                                  <Grid container sx={{ backgroundColor: getDocumentBackGroundColor(0), borderRadius: "10px", height: '250px', width: '100%', marginRight: '2%' }} className="docContainer">
                                                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                                                      <div onClick={() => { if (!paidDNImagePopUp) { setPaidDNImagePopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                                                        <Base64Image data={dnImage} width={80} />
                                                      </div>
                                                      {
                                                        paidDNImagePopUp &&
                                                        <OpenBase64ImageInPopup
                                                          docVerifyPopUp={paidDNImagePopUp}
                                                          hideDocVerifyPopup={hidePaidDnImagePopUp}
                                                          documentName="Paid DN Image"
                                                          documentImage={dnImage}
                                                          width={'100%'}
                                                          document={dnImage}
                                                          documentFlag={1}
                                                          applicationProgressId={dialogRowData.applicationProgressId}
                                                          objectionStatus={dialogRowData.objectionStatus}
                                                          updateDocFlag={updateDocFlag}
                                                          titleToUpdateFlag="copyOfApplicantCNIC"
                                                          flag_document={1}
                                                        />
                                                      }
                                                    </Grid>
                                                  </Grid>
                                                </Grid>
                                                <Grid item lg={4.5} className='item'  >
                                                  <Typography className='title'>Customer ID. Front</Typography>
                                                  <Grid container sx={{ backgroundColor: getDocumentBackGroundColor(0), borderRadius: "10px", height: '250px', width: '100%' }} className="docContainer">
                                                    <img src={dialogRowData.applicantCNICFront} alt="Cnic Front" style={{ width: '100%', height: '100%' }} ></img>
                                                  </Grid>
                                                </Grid>
                                                <Grid item lg={4.5} className='item' >
                                                  <Typography className='title'>Customer ID. Back</Typography>
                                                  <Grid container sx={{ backgroundColor: getDocumentBackGroundColor(0), borderRadius: "10px", height: '250px', width: '100%' }} className="docContainer">
                                                    <img src={dialogRowData.applicantCNICBack} alt="Cnic Back" style={{ width: '100%', height: '100%' }} ></img>
                                                  </Grid>
                                                </Grid>
                                              </Grid>
                                            </> :
                                            dialogRowData.applicationProgressId === 6 && dialogRowData.objectionStatus === 1 ?
                                              <>
                                                <h3 className='step-title'>Meter Installation Objection</h3>
                                                <p className='group-description'>Unable to get details of the demand notice payment. Please contact the relevant field operations officer! </p>
                                              </> :
                                              dialogRowData.applicationProgressId === 7 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                <>
                                                  <Grid container className='step-title'>
                                                    <Grid item lg={1}>
                                                    </Grid>
                                                    <Grid item lg={10} sx={{ textAlign: 'center' }}>
                                                      <h3 style={{ fontWeight: 'normal', fontSize: '1.2vw' }}>Service Connection Order</h3>
                                                    </Grid>
                                                    <Grid item lg={1}>
                                                      <Button variant="outlined" onClick={() => downloadSJOPDF(dialogRowData.applicationId, 'Change of Tariff')} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><PrintIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> SCO</Button>
                                                    </Grid>
                                                  </Grid>
                                                  <Grid container className='sco-container'>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>Application Id.</Typography>
                                                      <Typography className='value'>{sjoDetails.applicationId ? sjoDetails.applicationId : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>SCO No.</Typography>
                                                      <Typography className='value'>{sjoDetails.sCONo ? sjoDetails.sCONo : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>SCO Creation Date</Typography>
                                                      <Typography className='value'>{sjoDetails.scoCreationDate ? convertDate(sjoDetails.scoCreationDate) : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>DN No.</Typography>
                                                      <Typography className='value'>{dnDetails.demandNoticeNo ? dnDetails.demandNoticeNo : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>DN Issue Date</Typography>
                                                      <Typography className='value'>{dnDetails.issueDate ? convertDate(dnDetails.issueDate) : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>DN Payment Date</Typography>
                                                      <Typography className='value'>{dnPaymentDate ? convertDate(dnPaymentDate) : '-'}</Typography>
                                                    </Grid>
                                                  </Grid>
                                                  <Grid container className='field-survey-container'>
                                                    <Grid item lg={12} className='group-title-item'>
                                                      <h5 className='group-title'>Applicant Information</h5>
                                                    </Grid>
                                                  </Grid>
                                                  <Grid container className='sco-container'>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>Applicant Name</Typography>
                                                      <Typography className='value'>{dialogRowData.applicantName ? dialogRowData.applicantName : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>Applicant CNIC</Typography>
                                                      <Typography className='value'>{dialogRowData.applicantCNIC ? dialogRowData.applicantCNIC : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>Applicant Phone</Typography>
                                                      <Typography className='value'>{dialogRowData.applicantPhoneNo ? dialogRowData.applicantPhoneNo : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>Applicant Email</Typography>
                                                      <Typography className='value'>{dialogRowData.applicantEmail ? dialogRowData.applicantEmail : '-'}</Typography>
                                                    </Grid>
                                                  </Grid>
                                                  <Grid container className='field-survey-container'>
                                                    <Grid item lg={12} className='group-title-item'>
                                                      <h5 className='group-title'>Tariff Information</h5>
                                                    </Grid>
                                                  </Grid>
                                                  <Grid container className='sco-container'>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>Old Tariff</Typography>
                                                      <Typography className='value'>{dialogRowData.currentTariff ? dialogRowData.currentTariff : '-'}</Typography>
                                                    </Grid>
                                                    <Grid item lg={2} className='item'>
                                                      <Typography className='title'>New Tariff</Typography>
                                                      <Typography className='value'>{dialogRowData.newTariff ? dialogRowData.newTariff : '-'}</Typography>
                                                    </Grid>
                                                  </Grid>
                                                </> :
                                                dialogRowData.applicationProgressId === 7 && dialogRowData.objectionStatus === 1 ?
                                                  <>
                                                    <h3 className='step-title'>Ready For Billing Objection</h3>
                                                    <p className='group-description'>Unable to get details. Please contact sub division office.</p>
                                                  </> :
                                                  dialogRowData.applicationProgressId === 8 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ?
                                                    <>
                                                      <Grid container className='step-title'>
                                                        <Grid item lg={1}>
                                                        </Grid>
                                                        <Grid item lg={10} sx={{ textAlign: 'center' }}>
                                                          <h3 style={{ fontWeight: 'normal', fontSize: '1.2vw' }}>Application Process Complete</h3>
                                                        </Grid>
                                                        <Grid item lg={1}>
                                                          <Button variant="outlined" onClick={() => downloadSJOPDF(dialogRowData.applicationId, 'Change of Tariff')} sx={{ backgroundColor: 'white', cursor: 'pointer', border: '1px solid #006ad1', boxShadow: 'none', width: '5%' }} ><PrintIcon sx={{ color: '#006ad1', marginLeft: '1%' }} /> SCO</Button>
                                                        </Grid>
                                                      </Grid>
                                                    </> : null
                  }
                </div>
                <div className='actions'>
                  {
                    dialogRowData.applicationProgressId === 0 ? //Document Submission
                      // CheckPermissions(permissions,'General Services', 'Change of Tariff', 'Basic Permissions', 'Update') ?
                      CheckPermissions(permissions, 'General Services', 'Change of Tariff') ?
                        <Button onClick={() => navigate('/change-of-load-update', { state: { dialogRowData } })} variant="contained" sx={{ backgroundColor: 'blue' }}>Upload Pending Documents</Button>
                        : null :
                      dialogRowData.applicationProgressId === 1 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ? // 
                        CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Document Verification') ?
                          <>
                            {
                              (
                                dialogRowData.applicantCNICFrontFlag !== 1 ||
                                dialogRowData.applicantCNICBackFlag !== 1 ||
                                dialogRowData.owenershipImageFlag !== 1 ||
                                dialogRowData.otherDocumentsFlag !== 1
                              )
                                ?
                                <>
                                  <button disabled={dialogRowData.applicantCNICFront ? (!flag_applicantCNICFront || !flag_applicantCNICBack) : !flag_applicantCNICFront} onClick={() => updateDocumentStatus()} className='view-button' style={{
                                    backgroundColor: (
                                      flag_applicantCNICFront === -1 || flag_applicantCNICBack === -1 ||
                                      flag_owenershipImage === -1 ||
                                      flag_otherDocuments === -1
                                    ) ? '#E11B3C' : '#003971'
                                  }} >
                                    {
                                      (
                                        flag_applicantCNICFront === -1 || flag_applicantCNICBack === -1 ||
                                        flag_owenershipImage === -1 ||
                                        flag_otherDocuments === -1
                                      ) ? 'Reject' : 'Verify'
                                    }
                                  </button>
                                </>
                                :
                                null
                            }
                          </> :
                          <>
                          </> :
                        dialogRowData.applicationProgressId === 1 && dialogRowData.objectionStatus === 1 ?
                          <>
                            {
                              CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Basic Permissions', 'Update') ?
                                <>
                                  <button onClick={() => navigate('/change-of-tariff-update', { state: { dialogRowData } })} className='view-button'>Re-Upload Document</button>
                                </> :
                                <>
                                </>
                            }
                          </> :
                          dialogRowData.applicationProgressId === 2 && //Arears Verification
                            (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ? // No Objection
                            CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Arears Verification') &&
                            <>
                              <button onClick={() => {
                                if (arrearFlag === 1) {
                                  arearsFormik.handleSubmit()
                                }
                                else {
                                  if (dialogRowData.objectionStatus === 2) {
                                    callResetObjectionStatus(dialogRowData.applicationId)
                                  }
                                  callChangeProgressIdAPI(dialogRowData.applicationProgressId + 1, "Arrears Verified", "Arrears Verified")
                                }
                              }} className='view-button'>Submit</button>
                              <button className='reject-button'
                                style={{ float: 'right', marginRight: '10px' }} onClick={() => {
                                  callAsyncResetDocsFlags(dialogRowData.applicationId)
                                  callChangeProgressIdAPI(1, 'Reverify Documents', '-', dialogRowData.applicationId)
                                }} >
                                Back
                              </button>
                            </> :
                            dialogRowData.applicationProgressId === 2 && dialogRowData.objectionStatus === 1 ?
                              CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Arears Verification')
                              &&
                              <>
                                <button onClick={showArrearsEntryPopup} className='view-button' >Check Arrears</button>
                                <button onClick={showRejectionRemovalAlert} className='view-button' style={{ marginRight: '10px' }}>Remove Objection</button>
                              </> :
                              dialogRowData.applicationProgressId === 3 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) ? // No Objection
                                CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Site Survey') ?
                                  <>
                                    {
                                      consentVerificationFlag === 1 &&
                                      <button onClick={() => { signedConsentImageFormik.handleSubmit() }} disabled={!signedConsentFormImageThumbnail} type="submit" className='view-button'>Submit</button>
                                    }
                                    {
                                      consentVerificationFlag === 0 &&
                                      <button onClick={() => { callChangeObjectionStatus('Site Survey', 1, 'Consent not verified') }} className='reject-button' style={{ float: 'right' }}>Submit</button>
                                    }
                                  </>
                                  : null :
                                dialogRowData.applicationProgressId === 3 && (dialogRowData.objectionStatus === 1) &&
                                  CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Site Survey') ?
                                  <>
                                    {
                                      // <button onClick={signedConsentFormFormik.handleSubmit} className='view-button'>Submit</button>
                                      <button onClick={() => { setSignedConsentRejectionRemovalAlert(true) }} className='view-button'>Remove Objection</button>
                                    }
                                  </> :
                                  dialogRowData.applicationProgressId === 4 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) &&
                                    CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Validate Signed Consent') ?
                                    <>
                                      <button className='view-button' onClick={() => callAsyncCreateDnForChangeOfTariff(dialogRowData.applicationId)} type='submit'>Approve</button>
                                      <button className='reject-button' style={{ float: 'right', marginRight: '10px' }} onClick={() => callChangeProgressIdAPI(dialogRowData.applicationProgressId - 1, 'Consent Rejected', '-', dialogRowData.applicationId)} type='submit'>Reject</button>
                                    </> :
                                    dialogRowData.applicationProgressId === 5 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) &&
                                      CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'DN Image Uploading') ?
                                      <>
                                        <button className='view-button' onClick={dnPymentReceiptFormik.handleSubmit} >Submit</button>
                                      </> :
                                      dialogRowData.applicationProgressId === 6 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) &&
                                        CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Demand Note Verification') ?
                                        <div>
                                          <button onClick={() => { callSJOCreationAPI(dialogRowData.applicationId) }} className='view-button' >Verify</button>
                                          <button onClick={() => {
                                            callChangeProgressIdAPI(dialogRowData.applicationProgressId - 1, "DN Payment Unverified", "DN Payment Unverified")
                                            setDnPaymentRejectAlert(false)
                                          }} className='reject-button' style={{ float: 'right', marginRight: '10px' }}>Reject</button>
                                        </div> :
                                        dialogRowData.applicationProgressId === 7 && (dialogRowData.objectionStatus === 0 || dialogRowData.objectionStatus === 2) &&
                                          CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Service Connection Order Appro') ?
                                          <button onClick={sjoFormik.handleSubmit} type="submit" className='view-button' >Approve</button>
                                          : null
                  }
                </div>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
      </Dialog >

      {/* Signed Consent Form Rejection Removal Alert */}
      < Dialog
        open={signedConsentRejectionRemovalAlert}
        onClose={hideSignedConsentRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={'sm'}
        className='rejection-removal'>
        <DialogTitle className='dialog-title'>
          Signed Consent Form
          <Box sx={{ marginRight: '2%' }} >
            <CloseIcon id="clearPopup" onClick={hideSignedConsentRejectionRemovalAlert} sx={{ color: 'white', cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <DialogContent>
          {
            CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Site Survey') ?
              <>
                <Grid container spacing={2} sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Grid item lg={7} >
                    <Typography sx={{ color: '#888888', fontSize: '0.75vw' }} >Owner Signed Consent received</Typography>
                    <FormControl >
                      <RadioGroup
                        defaultValue={consentVerificationFlag}
                        value={consentVerificationFlag}
                        name="iv_consent_flag"
                        onChange={() => { if (consentVerificationFlag === 1) { setConsentVerificationFlag(0) } else { setConsentVerificationFlag(1) } }}
                        row
                      >
                        <FormControlLabel value={1} className='option-left' sx={{
                          padding: '0px 30px', marginRight: '15px', backgroundColor: 'white',
                          borderRadius: '5px',
                          marginLeft: '0px',
                          border: '1px solid lightgrey'
                        }} control={<Radio />} label="Yes" />
                        <FormControlLabel value={0} className='option-left' sx={{
                          padding: '0px 30px', marginRight: '15px', backgroundColor: 'white',
                          borderRadius: '5px',
                          marginLeft: '0px',
                          border: '1px solid lightgrey'
                        }} control={<Radio />} label="No" />
                      </RadioGroup>
                    </FormControl>
                  </Grid>
                  {
                    consentVerificationFlag == 1 &&
                    <Grid item lg={4}>
                      <Typography sx={{ color: '#888888', fontSize: '0.75vw' }} >Signed Consent Image</Typography>
                      {
                        signedConsentFormImage ?
                          <>
                            <Button varient='outlined' component="label" startIcon={<CloseIcon sx={{ color: 'red' }} onClick={() => { setSignedConsentFormImageImage('') }} />}  >
                              {signedConsentFormImageThumbnail && <img src={signedConsentFormImageThumbnail} alt="Signed Consent Form" width="80" />}
                            </Button>
                          </>
                          :
                          <>
                            <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />} sx={{ padding: '4%', width: '100%', backgroundColor: 'white' }}  >
                              Upload
                              <input hidden accept={documentExtensions} id='iv_signed_consent_image' name='iv_signed_consent_image' type="file" onChange={SignedConsentFormImage} />
                            </Button>
                          </>
                      }
                    </Grid>
                  }

                </Grid>
              </>
              : null
          }
        </DialogContent>
        <DialogActions>
          <Button variant='contained' disabled={!signedConsentFormImageThumbnail} className='confirmButton' sx={{ width: '30%', textTransform: 'capitalize' }} onClick={() => { callChangeObjectionStatus('Site Survey', 0, 'Signed Consent Received', '-'); signedConsentImageFormik.handleSubmit(); setSignedConsentRejectionRemovalAlert(false); }}>Confirm</Button>
        </DialogActions>
      </Dialog >

      {/* Arrears Rejection Removal Alert */}
      < Dialog
        open={arrearRejectionRemovalAlert}
        onClose={hideArrearRejectionRemovalAlert}
        fullWidth={true}
        maxWidth={'sm'}
        className='rejection-removal'>
        <DialogTitle className='dialog-title'>
          Arrears Verification
          <Box sx={{ marginRight: '2%' }} >
            <CloseIcon id="clearPopup" onClick={hideArrearRejectionRemovalAlert} sx={{ color: 'white', cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <DialogContent>
          {
            CheckPermissions(permissions, 'General Services', 'Change of Tariff', 'Workflow Permissions', 'Arrear Bill Uploading') ?
              <>
                <Grid container item lg={12} sx={{ display: 'flex', flexDirection: 'row' }}>
                  <Grid item lg={4} sx={{ marginTop: '2%', display: 'flex', flexDirection: 'column', marginRight: '8%' }}>
                    <Typography sx={{ fontWeight: 'normal', marginBottom: '1%', color: '#808080' }} >Payment Date</Typography>
                    <input
                      name="iv_arear_paid_bill_date"
                      value={arearBillDocumentFormik.values.iv_arear_paid_bill_date}
                      onChange={arearBillDocumentFormik.handleChange}
                      onBlur={arearBillDocumentFormik.handleBlur}
                      type='date'
                      style={{
                        padding: '10px',          // Corrected syntax
                        borderRadius: '5px',     // Enclosed in quotes
                        border: '1px solid #ccc', // Corrected syntax and enclosed in quotes
                        marginBottom: '10px',
                        width: '100%'   // Corrected syntax and enclosed in quotes
                      }}
                      max={new Date().toISOString().split('T')[0]}
                    />
                    <Box className='form-error' sx={{ color: 'red', marginTop: '1%' }}>{arearBillDocumentFormik.errors.iv_arear_paid_bill_date && arearBillDocumentFormik.touched.iv_arear_paid_bill_date ? (arearBillDocumentFormik.errors.iv_arear_paid_bill_date) : null}</Box>
                  </Grid>
                  <Grid item lg={6} sx={{ marginTop: '2%', marginRight: '8%' }}>
                    <Typography sx={{ fontWeight: 'normal', marginBottom: '1%', color: '#808080' }} >Paid Bill Image</Typography>
                    {
                      arearPaidBillDocument ?
                        <>
                          <Button varient='outlined' component="label" startIcon={<CloseIcon sx={{ color: 'red' }} onClick={() => { setArearPaidBillDocument('') }} />}  >
                            {arearPaidBillDocumentThumbnail && <img src={arearPaidBillDocumentThumbnail} alt="Arear paid bill" width="100" />}
                          </Button>
                        </>
                        :
                        <>
                          <Button variant="outlined" component="label" startIcon={<FileUploadOutlinedIcon />} className='btn' sx={{ marginTop: '2%', width: '70%' }}>
                            Upload
                            <input hidden accept={documentExtensions} id='iv_arear_paid_bill_document' name='iv_arear_paid_bill_document' type="file" onChange={ArearPaidBillDocument} />
                          </Button>
                        </>
                    }
                    <Box className='documentError' sx={{ color: 'red', marginTop: '1%' }}>{arearBillDocumentFormik.errors.iv_arear_paid_bill_document && arearBillDocumentFormik.touched.iv_arear_paid_bill_document ? (arearBillDocumentFormik.errors.iv_arear_paid_bill_document) : null}</Box>
                  </Grid>
                </Grid>
              </>
              : null
          }
        </DialogContent>
        <DialogActions>
          <Button variant='contained' className='confirmButton' sx={{ width: '30%', textTransform: 'capitalize' }} type='submit' onClick={arearBillDocumentFormik.handleSubmit}>Confirm</Button>
        </DialogActions>
      </Dialog >


      {/* Arrears Entry Dialog */}
      < Dialog
        open={arrearsEntryPopUpOpen}
        onClose={hideArrearsEntryAlert}
        fullWidth={true}
        maxWidth="lg"
        className='alert-popups' >
        <DialogTitle sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }} className='dialog-title'>
          Arrear Details
          <Box sx={{ marginTop: '1%' }} >
            <CloseIcon id="clearPopup" onClick={hideArrearsEntryAlert} sx={{ color: 'white', cursor: 'pointer' }} />
          </Box>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText className='dialog-content-text'>
            <p>Reference number associated to the property:</p>
            <TextField
              required
              type='text'
              name="iv_property_reference_no"
              value={arearsFormik.values.iv_property_reference_no}
              inputProps={{ maxLength: 14 }}
              onChange={arearsFormik.handleChange}
              disabled={true}
              onBlur={arearsFormik.handleBlur}
              id="iv_property_reference_no"
              className='arearsReferenceNumber'
            />
            <Box className="form-error">
              {arearsFormik.errors.iv_property_reference_no && arearsFormik.touched.iv_property_reference_no ? (arearsFormik.errors.iv_property_reference_no) : null}
            </Box>
            {
              (arearsFormik.values.iv_property_reference_no.length === 14 &&
                arrearsDetails.arrearsAmount) ?
                <>
                  <Grid item lg={12}>
                    <hr style={{ marginTop: '2%', marginBottom: '1%' }} />
                  </Grid>
                  <Grid item container spacing={2} className='arrear-entery-container'>
                    <Grid item lg={4}>
                      <Typography sx={{ fontSize: 13, color: '#888888' }}>Arrear Amount</Typography>
                      <Typography className='arrear-entery-label' >{arrearsDetails.arrearsAmount ? arrearsDetails.arrearsAmount : '-'}</Typography>
                    </Grid>
                    <Grid item lg={4}>
                      <Typography sx={{ fontSize: 13, color: '#888888' }}>Consumer Name</Typography>
                      <Typography className='arrear-entery-label' >{arrearsDetails.consumerName ? arrearsDetails.consumerName : '-'}</Typography>
                    </Grid>
                    <Grid item lg={4}>
                      <Typography sx={{ fontSize: 13, color: '#888888' }}>Consumer Phone No.</Typography>
                      <Typography className='arrear-entery-label'>{arrearsDetails.consumerNo ? arrearsDetails.consumerNo : '-'}</Typography>
                    </Grid>
                    <Grid item lg={12}>
                      <Typography sx={{ fontSize: 13, color: '#888888' }}  >Consumer Address</Typography>
                      <Typography className='arrear-entery-label' >{arrearsDetails.consumerAddress ? arrearsDetails.consumerAddress : '-'}</Typography>
                    </Grid>
                    <Grid item lg={12}>
                    </Grid>
                  </Grid>
                </>
                :
                <Box sx={{ color: '#00B091', marginTop: '2%', backgroundColor: '#DFFFE4', padding: '1%', width: '96%', display: 'flex', flexDirection: 'row' }}>
                  <ErrorIcon style={{ color: '#00B091', marginLeft: '1%' }} />
                  <h4 style={{ marginLeft: '10px', fontSize: '1vw' }}>{noArrears}</h4>
                </Box>
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" className='arrearBtn' sx={{ width: '15%' }} onClick={arearsFormik.handleSubmit} >Confirm</Button>
        </DialogActions>
      </Dialog >

      {/* DN Payment Verification Alert */}
      < Dialog
        open={dnPaymentVerifyAlert}
        onClose={hideDnPaymentVerifyAlert}
        fullWidth={true}
        maxWidth={'sm'}
        className='' >
        <DialogTitle>
          Alert!
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography className='fieldLabel' >Are you surely want to verify the demand notice payment?</Typography>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            callSJOCreationAPI(dialogRowData.applicationId)
            hideDnPaymentVerifyAlert()
          }}>Submit</Button>
          <Button onClick={hideDnPaymentVerifyAlert}>Cancel</Button>
        </DialogActions>
      </Dialog >

      {/* Application Submitted Sub pop up */}
      < Dialog
        open={applicationSubittedPopUp}
        onClose={() => { setApplicationSubmittedPopUp(false) }}
        fullWidth={true}
        maxWidth={'lg'}
        className='subpopup-dialog1' >
        <DialogTitle className='dialog-title'>
          <p className='title'>
            Application Submitted
          </p>
          <CloseIcon id="clearPopup" className='closeIcon' onClick={() => { setApplicationSubmittedPopUp(false) }} />
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <Grid container gap={1} className='container' >
            <Grid item lg={12} className='application-details'>
              <Grid item lg={3} className='first-row-item' >
                <p className='prop-title'>Application Id</p>
                <p className=' prop-detail'>{dialogRowData.applicationId}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applicant Name</p>
                <p className=' prop-detail'>{dialogRowData.applicantName}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applicant CNIC.</p>
                <p className=' prop-detail'>{dialogRowData.applicantCNIC}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applicant Phone</p>
                <p className=' prop-detail'>{dialogRowData.applicantPhoneNo}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applicant Email</p>
                <p className=' prop-detail'>{dialogRowData.applicantEmail}</p>
              </Grid>
            </Grid>
            <Grid item lg={12} className='application-details1'>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Applied Date</p>
                <p className=' prop-detail'>{convertDate(dialogRowData.creationDate)}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Subdivision</p>
                <p className=' prop-detail'>{subdivisionName(dialogRowData.subDivisionCode, subDivisions)}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item' >
                <p className='prop-title'>Sub. Through</p>
                <p className=' prop-detail'>{dialogRowData.submittedThrough}</p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='dialog-action'>
          <p className='description'>Application Submitted by: {dialogRowData.applicantName} on: {convertDatewithTime(dialogRowData.creationDate)}</p>
        </DialogActions>
      </Dialog >

      {/* Documents Verified Sub Pop Up */}
      < Dialog
        open={documentsVerifiedSubPopUp}
        onClose={() => { setDocumentsVerifiedSubPopUp(false) }}
        fullWidth={true}
        maxWidth={'md'}
        className='subpopup-dialog1' >
        <DialogTitle className='dialog-title'>
          <p className='title'>
            Documents Verified
          </p>
          <CloseIcon id="clearPopup" className='closeIcon' onClick={() => { setDocumentsVerifiedSubPopUp(false) }} />
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <Grid container gap={1} className='container' style={{ display: 'flex', flexDirection: 'row' }} >
            <Grid item lg={12} style={{ display: 'flex', flexDirection: 'row' }}>
              {
                (dialogRowData.applicantCNICFront || dialogRowData.applicantCNICBack) &&
                <Grid item lg={2}>
                  <Grid container sx={{ backgroundColor: (dialogRowData.applicantCNICFrontFlag && dialogRowData.applicantCNICBackFlag) ? getDocumentBackGroundColor(dialogRowData.applicantCNICFrontFlag) : getDocumentBackGroundColor(flag_applicantCNICFront), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                      <div onClick={() => { if (!copyOfApplicantCNICVerifyPopUp) { setCopyOfApplicantCNICVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }} >
                        {
                          dialogRowData.applicantCNICFront.slice(0, 6) === 'data:i' ? (
                            flag_applicantCNICFront === 1 ? (
                              <>
                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                                <img
                                  src={tickicon}
                                  width='25px'
                                  height='25px'
                                  alt="Tick Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : flag_applicantCNICFront === -1 ? (
                              <>
                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                                <img
                                  src={crossIcon}
                                  width='25px'
                                  height='25px'
                                  alt="Cross Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : (
                              <>
                                <Base64Image data={dialogRowData.applicantCNICFront} width='80' height='50' />
                                <Base64Image data={dialogRowData.applicantCNICBack} width='80' height='50' />
                              </>
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width='40' />
                          )
                        }
                        {
                          copyOfApplicantCNICVerifyPopUp &&
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={copyOfApplicantCNICVerifyPopUp}
                            hideDocVerifyPopup={hideCopyOfApplicantCNICVerifyAlert}
                            documentName="Applicant CNIC"
                            documentImage={dialogRowData.applicantCNICFront}
                            backDocumentImage={dialogRowData.applicantCNICBack}
                            width={'100%'}
                            document={dialogRowData.applicantCNICFront}
                            documentFlag={dialogRowData.applicantCNICFrontFlag}
                            applicationProgressId={dialogRowData.applicationProgressId}
                            objectionStatus={dialogRowData.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="copyOfApplicantCNIC"
                            flag_document={flag_applicantCNICFront}
                            flag_documentBack={flag_applicantCNICBack}
                          />
                        }
                      </div>
                    </Grid>
                    <Grid item lg={12} className="tittlegrid" >
                      <p className='docTitle'>Applicant's CNIC.</p>
                    </Grid>
                  </Grid>
                </Grid>
              }
              {
                dialogRowData.owenershipImage &&
                <Grid item lg={2}>
                  <Grid container sx={{ backgroundColor: dialogRowData.owenershipImageFlag ? getDocumentBackGroundColor(dialogRowData.owenershipImageFlag) : getDocumentBackGroundColor(flag_owenershipImage), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                      <div onClick={() => { if (!owenershipImageVerifyPopUp) { setOwenershipImageVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                        {
                          dialogRowData.owenershipImage.slice(0, 6) === 'data:i' ? (
                            flag_owenershipImage === 1 ? (
                              <>
                                <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                                <img
                                  src={tickicon}
                                  width='25px'
                                  height='25px'
                                  alt="Tick Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : flag_owenershipImage === -1 ? (
                              <>
                                <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                                <img
                                  src={crossIcon}
                                  width='25px'
                                  height='25px'
                                  alt="Cross Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : (
                              <Base64Image data={dialogRowData.owenershipImage} width='80' height='110' />
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width='40' />
                          )
                        }
                        {
                          owenershipImageVerifyPopUp &&
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={owenershipImageVerifyPopUp}
                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                            documentName="Property Document"
                            documentImage={dialogRowData.owenershipImage}
                            width={'100%'}
                            document={dialogRowData.owenershipImage}
                            documentFlag={dialogRowData.owenershipImageFlag}
                            applicationProgressId={dialogRowData.applicationProgressId}
                            objectionStatus={dialogRowData.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="owenershipImage"
                            flag_document={flag_owenershipImage}
                          />
                        }
                      </div>
                    </Grid>
                    <Grid item lg={12} className="tittlegrid" >
                      <p className='docTitle'>Property Documents</p>
                    </Grid>
                  </Grid>
                </Grid>
              }
              {
                (dialogRowData.otherDocuments) &&
                <Grid item lg={2}>
                  <Grid container sx={{ backgroundColor: (dialogRowData.otherDocumentsFlag) ? getDocumentBackGroundColor(dialogRowData.otherDocumentsFlag) : getDocumentBackGroundColor(flag_otherDocuments), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', paddingBottom: '5px' }}>
                      <div onClick={() => { if (!otherDocumentsVerifyPopUp) { setOtherDocumentsVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between', flexDirection: 'column', alignItems: 'center' }} >
                        {
                          dialogRowData.otherDocuments.slice(0, 6) === 'data:i' ? (
                            flag_otherDocuments === 1 ? (
                              <>
                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='110' />

                                <img
                                  src={tickicon}
                                  width='25px'
                                  height='25px'
                                  alt="Tick Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : flag_otherDocuments === -1 ? (
                              <>
                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='110' />

                                <img
                                  src={crossIcon}
                                  width='25px'
                                  height='25px'
                                  alt="Cross Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : (
                              <>
                                <Base64Image data={dialogRowData.otherDocuments} width='80' height='110' />

                              </>
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width='40' />
                          )
                        }
                        {
                          otherDocumentsVerifyPopUp &&
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={otherDocumentsVerifyPopUp}
                            hideDocVerifyPopup={hideOtherDocumentsVerifyAlert}
                            documentName="Previous Owner CNIC"
                            documentImage={dialogRowData.otherDocuments}
                            // // backDocumentImage={dialogRowData.otherDocumentsBack}
                            width={'100%'}
                            document={dialogRowData.otherDocuments}
                            documentFlag={dialogRowData.otherDocumentsFlag}
                            applicationProgressId={dialogRowData.applicationProgressId}
                            objectionStatus={dialogRowData.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="otherDocuments"
                            flag_document={flag_otherDocuments}
                          // // flag_documentBack={flag_otherDocumentsBack}
                          />
                        }
                      </div>
                    </Grid>
                    <Grid item lg={12} className="tittlegrid" >
                      <p className='docTitle'>Other Document</p>
                    </Grid>
                  </Grid>
                </Grid>
              }
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='dialog-action'>
          <p className='description'>Documents Verified by: {eFileData.find(item => item.remarks == "Documents Verified") ? eFileData.find(item => item.remarks == "Documents Verified").lastModifiedBy : ''} {eFileData.find(item => item.remarks == "Documents Verified") ? '(' + eFileData.find(item => item.remarks == "Documents Verified").roleName + ')' : ''} on: {eFileData.find(item => item.remarks == "Documents Verified") ? convertDatewithTime(eFileData.find(item => item.remarks == "Documents Verified").lastModificationDate) : ''}</p>
        </DialogActions>
      </Dialog >

      {/* Arrear Verified Sub Pop Up */}
      < Dialog
        open={arrearVerifiedSubPopUp}
        onClose={() => { setArrearVerifiedSubPopUp(false) }}
        fullWidth={true}
        maxWidth={'sm'}
        className='subpopup-dialog1'
      >
        <DialogTitle className='dialog-title'>
          <p className='title'>
            Arrear Verified
          </p>
          <CloseIcon id="clearPopup" onClick={() => { setArrearVerifiedSubPopUp(false) }} className='closeIcon' />
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <DialogContentText>
            {
              dialogRowData.applicationProgressId > 3 ?
                <p>All dues were <span style={{ fontWeight: 'bold', color: 'green' }}>PAID</span> against the property.</p> :
                <p>Arrears verification is in process.</p>
            }
          </DialogContentText>
        </DialogContent>
        <DialogActions className='dialog-action'>
          {
            dialogRowData.applicationProgressId > 3 ?
              <p className='description'>Arrear Verified by: System on: {eFileData.find(item => item.remarks == "Arrears Verified") ? convertDatewithTime(eFileData.find(item => item.remarks == "Arrears Verified").lastModificationDate) : ''}</p> :
              <p className='description'>-</p>
          }
        </DialogActions>
      </Dialog >

      {/* Site Survey Sub Pop Up */}
      < Dialog
        open={fieldSurveyedSubPopUp}
        onClose={() => { setFieldSurveyedSubPopUp(false) }}
        fullWidth={true}
        maxWidth={'md'}
        className='subpopup-dialog1' >
        <DialogTitle className='dialog-title'>
          <p className='title'>
            Site Surveyed
          </p>
          <CloseIcon id="clearPopup" onClick={() => { setFieldSurveyedSubPopUp(false) }} className='closeIcon' />
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <Grid container className='container'>
            <Grid item lg={12} className='application-details'>
              {
                consentImageDetails.consentImageChnageofTariff &&
                <Grid item lg={2}>
                  <Grid container sx={{ backgroundColor: dialogRowData.owenershipImageFlag ? getDocumentBackGroundColor(dialogRowData.owenershipImageFlag) : getDocumentBackGroundColor(flag_owenershipImage), borderRadius: "10px", minHeight: "150px", height: 'auto' }}>
                    <Grid item lg={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', }}>
                      <div onClick={() => { if (!owenershipImageVerifyPopUp) { setOwenershipImageVerifyPopUp(true) } }} style={{ display: 'flex', justifyContent: 'space-between' }} >
                        {
                          consentImageDetails.consentImageChnageofTariff.slice(0, 6) === 'data:i' ? (
                            flag_owenershipImage === 1 ? (
                              <>
                                <Base64Image data={consentImageDetails.consentImageChnageofTariff} width='80' height='110' />
                                <img
                                  src={tickicon}
                                  width='25px'
                                  height='25px'
                                  alt="Tick Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : flag_owenershipImage === -1 ? (
                              <>
                                <Base64Image data={consentImageDetails.consentImageChnageofTariff} width='80' height='110' />
                                <img
                                  src={crossIcon}
                                  width='25px'
                                  height='25px'
                                  alt="Cross Icon"
                                  className="doc-verification-status-icon"
                                />
                              </>
                            ) : (
                              <Base64Image data={consentImageDetails.consentImageChnageofTariff} width='80' height='110' />
                            )
                          ) : (
                            <Base64Image data={pdfIcon} width='40' />
                          )
                        }
                        {
                          owenershipImageVerifyPopUp &&
                          <OpenBase64ImageInPopup
                            docVerifyPopUp={owenershipImageVerifyPopUp}
                            hideDocVerifyPopup={hidePropertyDocVerifyAlert}
                            documentName="Property Document"
                            documentImage={consentImageDetails.consentImageChnageofTariff}
                            width={'100%'}
                            document={consentImageDetails.consentImageChnageofTariff}
                            documentFlag={dialogRowData.owenershipImageFlag}
                            applicationProgressId={dialogRowData.applicationProgressId}
                            objectionStatus={dialogRowData.objectionStatus}
                            updateDocFlag={updateDocFlag}
                            titleToUpdateFlag="owenershipDocument"
                            flag_document={flag_owenershipImage}
                          />
                        }
                      </div>
                    </Grid>
                    <Grid item lg={12} className="tittlegrid" >
                      <p className='docTitle'>Consent Image</p>
                    </Grid>
                  </Grid>
                </Grid>
              }
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='dialog-action'>
          <p className='description'>Site Surveyed by: {eFileData.find(item => item.remarks == "Site Surveyed") ? eFileData.find(item => item.remarks == "Site Surveyed").lastModifiedBy : ''} {eFileData.find(item => item.remarks == "Site Surveyed") ? '(' + eFileData.find(item => item.remarks == "Site Surveyed").roleName + ')' : ''} on: {eFileData.find(item => item.remarks == "Site Surveyed") ? convertDatewithTime(eFileData.find(item => item.remarks == "Site Surveyed").lastModificationDate) : ''}</p>
        </DialogActions>
      </Dialog >

      {/* Reference No. Allocation Sub Pop Up */}
      < Dialog
        open={referenceNoAllocatedSubPopUp}
        onClose={() => { setReferenceNoAllocatedSubPopUp(false) }}
        fullWidth={true}
        maxWidth={'md'}
        className='subpopup-dialog1' >
        <DialogTitle className='dialog-title'>
          <p className='title' >
            Demand Note Issued
          </p>
          <div>
            <PrintIcon onClick={() => downloadDNPDF(dialogRowData)} className='printIcon' />
            <CloseIcon id="clearPopup" onClick={() => { setReferenceNoAllocatedSubPopUp(false) }} className='closeIcon' />
          </div>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <Grid container className='container'>
            <Grid item lg={12} className='application-details'>

              <Grid item lg={2.5} className='first-row-item'>
                <p className='prop-title'>Demand Notice No. </p>
                <p className='prop-detail'>{dnDetails ? dnDetails.demandNoticeNo : '-'}</p>
              </Grid>
              <Grid item lg={2.5} className='first-row-item'>
                <p className='prop-title'>Reference No. </p>
                <p className='prop-detail'>{dnDetails ? dnDetails.connectionAccountNo : '-'}</p>
              </Grid>
              <Grid item lg={2.5} className='first-row-item'>
                <p className='prop-title'>DN Issue Date </p>
                <p className='prop-detail'>{dnDetails ? convertDate(dnDetails.issueDate) : '-'}</p>
              </Grid>
              <Grid item lg={2.5} className='first-row-item'>
                <p className='prop-title'>DN Due Date </p>
                <p className='prop-detail'>{dnDetails ? convertDate(dnDetails.dueDate) : '-'}</p>
              </Grid>
            </Grid>
            <Grid item lg={12} className='application-details'>

              <Grid item lg={2.5} className='first-row-item'>
                <p className='prop-title'>Capital Cost </p>
                <p className='prop-detail'>{dnDetails ? dnDetails.dNamount ? numberFormatting(dnDetails.dNamount) : '-' : '-'}</p>
              </Grid>
              <Grid item lg={2.5} className='first-row-item'>
                <p className='prop-title'>Bank Name</p>
                <p className='prop-detail'>{dnDetails ? dnDetails.bankName : '-'}</p>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='dialog-action'>
          <p className='description'>Demand Notice Approved by: {eFileData.find(item => item.remarks == "Demand Notice Created") ? eFileData.find(item => item.remarks == "Demand Notice Created").lastModifiedBy : ''} {eFileData.find(item => item.remarks == "Demand Notice Created") ? '(' + eFileData.find(item => item.remarks == "Demand Notice Created").roleName + ')' : ''} on: {eFileData.find(item => item.remarks == "Demand Notice Created") ? convertDatewithTime(eFileData.find(item => item.remarks == "Demand Notice Created").lastModificationDate) : ''}</p>
        </DialogActions>
      </Dialog >

      {/* DN Payment Submitted Pub Pop Up */}
      < Dialog
        open={dnPaymentSubmittedSubPopUp}
        onClose={() => { setDnPaymentSubmittedSubPopUp(false) }}
        fullWidth={true}
        maxWidth={'md'}
        className='subpopup-dialog1' >
        <DialogTitle className='dialog-title'>
          <p className='title'>
            DN Payment Submitted
          </p>
          <div>
            <CloseIcon id="clearPopup" onClick={() => { setDnPaymentSubmittedSubPopUp(false) }} className='closeIcon' />
          </div>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <Grid container className='container'>
            <Grid item lg={7} className='application-details'>
              <Grid item lg={3.5} className='first-row-item'>
                <p className='prop-title'>Demand Notice No. </p>
                <p className='prop-detail'>{paidDnImageDetails ? paidDnImageDetails.demandNoticeNo ? paidDnImageDetails.demandNoticeNo : '-' : '-'}</p>
              </Grid>
              <Grid item lg={3.5} className='first-row-item'>
                <p className='prop-title'>Payment Date </p>
                <p className='prop-detail'>{paidDnImageDetails ? paidDnImageDetails.paymentDate ? convertDate(paidDnImageDetails.paymentDate) : '-' : '-'}</p>
              </Grid>
              {
                paidDnImageDetails.paidDNImage &&
                <Grid item lg={3} className='first-row-item'>
                  <p className='prop-title'>Paid DN Image </p>
                  <div className='prop-detail'>
                    <a href="#" onClick={() => openBase64Image(paidDnImageDetails.paidDNImage)} target='_blank' rel="noreferrer" className='item' >
                      <Base64Image data={paidDnImageDetails.paidDNImage} width={80} />
                    </a>
                  </div>
                </Grid>
              }
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='dialog-action'>
          <p className='description'>Paid Demand Notice Image Uploaded by:  {eFileData.find(item => item.remarks == "Demand Notice Paid") ? eFileData.find(item => item.remarks == "Demand Notice Paid").lastModifiedBy : ''} {eFileData.find(item => item.remarks == "Demand Notice Paid") ? '(' + eFileData.find(item => item.remarks == "Demand Notice Paid").roleName + ')' : ''} on: {eFileData.find(item => item.remarks == "Demand Notice Paid") ? convertDatewithTime(eFileData.find(item => item.remarks == "Demand Notice Paid").lastModificationDate) : ''}</p>
        </DialogActions>
      </Dialog >

      {/* DN Payment Verified Sub Pop Up */}
      < Dialog
        open={dnPaymentVerifiedSubPopUp}
        onClose={() => { setDnPaymentVerifiedSubPopUp(false) }}
        fullWidth={true}
        maxWidth={'md'}
        className='subpopup-dialog1' >
        <DialogTitle className='dialog-title'>
          <p className='title'>
            DN Payment Verified
          </p>
          <div>
            <CloseIcon id="clearPopup" onClick={() => { setDnPaymentVerifiedSubPopUp(false) }} className='closeIcon' />
          </div>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <Grid container className='container'>
            <Grid item lg={7} className='application-details'>

              <Grid item lg={3.5} className='first-row-item'>
                <p className='prop-title'>Demand Notice No. </p>
                <p className='prop-detail'>{paidDnImageDetails ? paidDnImageDetails.demandNoticeNo : '-'}</p>
              </Grid>
              <Grid item lg={3} className='first-row-item'>
                <p className='prop-title'>Payment Date </p>
                <p className='prop-detail'>{paidDnImageDetails ? convertDate(paidDnImageDetails.paymentDate) : '-'}</p>
              </Grid>
            </Grid>
            <Grid item lg={6}></Grid>
            <Grid item lg={12} className='application-details'>

              {
                paidDnImageDetails.paidDNImage &&
                <Grid item lg={3} className='first-row-item'>
                  <p className='prop-title'>Paid DN Image </p>
                  <div className='prop-detail'>
                    <a href="#" onClick={() => openBase64Image(paidDnImageDetails.paidDNImage)} target='_blank' rel="noreferrer" className='item' >
                      <Base64Image data={paidDnImageDetails.paidDNImage} width={80} />
                    </a>
                  </div>
                </Grid>
              }
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className='dialog-action'>
          <p className='description'>Demand Notice Payment Verified by: {paidDnImageDetails.paidDNImageVerifiedBy} (CSL) on: {convertDatewithTime(paidDnImageDetails.paidDNImageVerifiedDateTime)}</p>
        </DialogActions>
      </Dialog >

      {/* Service Connection Order Sub Pop Up */}
      < Dialog
        open={serviceConnectionOrderedSubPopUp}
        onClose={() => { setServiceConnectionOrderedSubPopUp(false) }}
        fullWidth={true}
        maxWidth={'lg'}
        className='subpopup-dialog1' >
        <DialogTitle className='dialog-title'>
          <p className='title'>
            Service Connection Ordered
          </p>
          <div>
            <CloseIcon id="clearPopup" onClick={() => { setServiceConnectionOrderedSubPopUp(false) }} className='closeIcon' />
          </div>
        </DialogTitle>
        <DialogContent className='dialog-content'>
          <Grid container className='container'>
            <Grid item lg={12} className='application-details'>

              <Grid item lg={2} className='first-row-item'>
                <p className='prop-title'>SCO No. </p>
                <p className='prop-detail'>{sjoDetails ? sjoDetails.sCONo : '-'}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item'>
                <p className='prop-title'>Account No.</p>
                <p className='prop-detail'>{sjoDetails ? sjoDetails.accountNo : '-'}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item'>
                <p className='prop-title'>Security Amount</p>
                <p className='prop-detail'>{sjoDetails ? sjoDetails.ammountOfSecurityDeposit : '-'}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item'>
                <p className='prop-title'>Applicant Name </p>
                <p className='prop-detail'>{sjoDetails ? sjoDetails.applicantNewName : '-'}</p>
              </Grid>
              <Grid item lg={2} className='first-row-item'>
                <p className='prop-title'>CNIC No. </p>
                <p className='prop-detail'>{sjoDetails ? sjoDetails.cNICNo : '-'}</p>
              </Grid>
            </Grid>

          </Grid>
        </DialogContent>
        <DialogActions className='dialog-action'>
          <p className='description'>Service Connection Order Issued by: {eFileData.find(item => item.remarks == "DN Payment Verified") ? eFileData.find(item => item.remarks == "DN Payment Verified").lastModifiedBy : ''} {eFileData.find(item => item.remarks == "DN Payment Verified") ? '(' + eFileData.find(item => item.remarks == "DN Payment Verified").roleName + ')' : ''} on: {eFileData.find(item => item.remarks == "DN Payment Verified") ? convertDatewithTime(eFileData.find(item => item.remarks == "DN Payment Verified").lastModificationDate) : ''}</p>
        </DialogActions>
      </Dialog >

      {/* Backdrop */}
      < Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000 }}
        open={viewBackdrop}
      >
        <AppLoader />
      </Backdrop >
    </>
  );
})

export default ChangeTariffTable;
